(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dc-buybox"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';
  function init(root) {
    if (root.dataset.dcReady === '1') return;
    root.dataset.dcReady = '1';
    var gal = root.querySelector('[data-dc-gal]');
    var wrapEl = root.closest('.dc') || document;
    var setAll = function (sel, value) {
      [].forEach.call(wrapEl.querySelectorAll(sel), function (e) { e.textContent = value; });
    };

    /* ── Gallery ─────────────────────────────────────────────────────── */
    if (gal) {
      var slides = [].slice.call(gal.querySelectorAll('.gal__f'));
      var thumbs = [].slice.call(gal.querySelectorAll('.gal__t'));
      var count = gal.querySelector('.gal__ct b');
      var total = gal.querySelector('[data-gal-total]');
      var at = 0;
      if (total) { total.textContent = String(slides.length); }

      var show = function (i) {
        if (!slides.length) { return; }
        at = (i + slides.length) % slides.length;
        slides.forEach(function (s, n) {
          s.classList.toggle('is-on', n === at);
          if (n === at) { s.removeAttribute('aria-hidden'); } else { s.setAttribute('aria-hidden', 'true'); }
        });
        thumbs.forEach(function (t, n) {
          t.classList.toggle('is-on', n === at);
          t.setAttribute('aria-selected', n === at ? 'true' : 'false');
        });
        if (count) { count.textContent = String(at + 1); }
      };

      thumbs.forEach(function (t) {
        t.addEventListener('click', function () { show(+t.getAttribute('data-i')); });
      });
      var prev = gal.querySelector('.gal__nav--p');
      var next = gal.querySelector('.gal__nav--n');
      if (prev) { prev.addEventListener('click', function () { show(at - 1); }); }
      if (next) { next.addEventListener('click', function () { show(at + 1); }); }

      /* Arrow keys, but only while the gallery has focus — hijacking them
         for the whole document is how a page becomes unusable. */
      gal.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight') { show(at + 1); e.preventDefault(); }
        if (e.key === 'ArrowLeft') { show(at - 1); e.preventDefault(); }
      });

      /* Swipe, because most of this traffic is a thumb on a phone. A drag
         more vertical than horizontal is the page scrolling, and is left
         alone. */
      var x0 = null, y0 = null;
      gal.addEventListener('touchstart', function (e) {
        x0 = e.touches[0].clientX; y0 = e.touches[0].clientY;
      }, { passive: true });
      gal.addEventListener('touchend', function (e) {
        if (x0 === null) { return; }
        var dx = e.changedTouches[0].clientX - x0, dy = e.changedTouches[0].clientY - y0;
        if (Math.abs(dx) > 44 && Math.abs(dx) > Math.abs(dy)) { show(at + (dx < 0 ? 1 : -1)); }
        x0 = null; y0 = null;
      }, { passive: true });
    }

    /* ── The size, which is the variant ──────────────────────────────────
       Every string below was produced by Liquid's money filter at render
       time and parked on the radio. Nothing here parses a price, and
       nothing multiplies one. */
    var variants = [].slice.call(root.querySelectorAll('input[name=id]'));
    var requirePick = root.getAttribute('data-require-pick') === '1';
    var atc = [].slice.call(wrapEl.querySelectorAll('[data-dc-atc]'));
    var echoWrap = wrapEl.querySelector('[data-echo-wrap]');

    var paint = function () {
      var on = variants.filter(function (v) { return v.checked; })[0];
      if (!on) { return; }
      setAll('[data-price-now]', on.getAttribute('data-price'));
      setAll('[data-echo]', on.getAttribute('data-title'));
      var hasCmp = on.getAttribute('data-has-cmp') === '1';
      [].forEach.call(wrapEl.querySelectorAll('[data-price-was]'), function (e) {
        e.hidden = !hasCmp;
        if (hasCmp) { e.textContent = on.getAttribute('data-cmp'); }
      });
      if (echoWrap && echoWrap.children.length === 0) {
        /* The sticky bar opens without a size because nothing is chosen
           yet. Once one is, it gets the separator and the echo — built
           rather than unhidden, so the markup does not ship a stray dot. */
        echoWrap.appendChild(document.createTextNode(' \u00B7 '));
        var s = document.createElement('span');
        s.setAttribute('data-echo', '');
        s.textContent = on.getAttribute('data-title');
        echoWrap.appendChild(s);
      }
      atc.forEach(function (b) {
        b.disabled = false;
        var lab = b.querySelector('[data-atc-label]');
        if (lab && b.getAttribute('data-label-add')) { lab.textContent = b.getAttribute('data-label-add'); }
      });
    };

    variants.forEach(function (v) { v.addEventListener('change', paint); });
    if (!requirePick) { paint(); }

    /* ── The size guide ──────────────────────────────────────────────── */
    var guide = root.querySelector('[data-dc-guide]');
    var panel = wrapEl.querySelector('[data-dc-guide-panel]');
    if (guide && panel) {
      guide.addEventListener('click', function () {
        var open = panel.hidden;
        panel.hidden = !open;
        guide.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    } else if (guide) {
      /* No guide block on the section: the link would open nothing, so it
         does not appear at all rather than appearing and doing nothing. */
      guide.hidden = true;
    }

    /* ── Quantity ────────────────────────────────────────────────────── */
    var q = root.querySelector('[data-qty]');
    if (q) {
      var clamp = function (n) { return Math.max(1, Math.min(99, isNaN(n) ? 1 : n)); };
      var step = function (d) { q.value = clamp(parseInt(q.value, 10) + d); };
      var mi = root.querySelector('[data-minus]');
      var pl = root.querySelector('[data-plus]');
      if (mi) { mi.addEventListener('click', function () { step(-1); }); }
      if (pl) { pl.addEventListener('click', function () { step(1); }); }
      q.addEventListener('change', function () { q.value = clamp(parseInt(q.value, 10)); });
    }

    /* ── Sticky bar ──────────────────────────────────────────────────────
       A scroll listener rather than an IntersectionObserver, and the reason
       is a real bug rather than a preference. An observer only fires when
       the intersection RATIO crosses a threshold, and an instant jump — the
       End key, or any anchor link to a section further down — takes the
       button from below the viewport to above it without ever intersecting.
       The observer sees zero, then zero, fires nothing, and the bar never
       appears for anybody who did not scroll by hand. */
    var stk = wrapEl.querySelector('[data-dc-sticky]');
    var anchor = root.querySelector('.bb__buy');
    if (stk && anchor) {
      var queued = false;
      var sync = function () {
        queued = false;
        stk.hidden = anchor.getBoundingClientRect().bottom > 0;
      };
      var onMove = function () {
        if (queued) { return; }
        queued = true;
        if (window.requestAnimationFrame) { window.requestAnimationFrame(sync); } else { setTimeout(sync, 16); }
      };
      window.addEventListener('scroll', onMove, { passive: true });
      window.addEventListener('resize', onMove);
      sync();
    }
  }
  function scan(ctx) {
    var scope = ctx && ctx.querySelectorAll ? ctx : document;
    [].forEach.call(scope.querySelectorAll('[data-dc-buy]'), init);
    if (scope !== document && scope.matches && scope.matches('[data-dc-buy]')) init(scope);
  }
  scan(document);
  document.addEventListener('shopify:section:load', function (e) { scan(e.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dc-reviews"] && !Shopify.designMode) return;
  try {
    
  (function () {
    'use strict';
    function init(root) {
      if (root.dataset.dcReady === '1') return;
      root.dataset.dcReady = '1';
      var grid = root.querySelector('[data-rv-grid]');
      if (grid) {
        var cards = [].slice.call(grid.querySelectorAll('.rv__c'));
        var chips = [].slice.call(root.querySelectorAll('[data-topic][aria-pressed]'));
        var more = root.querySelector('[data-rv-more]');
        var none = root.querySelector('[data-rv-none]');
        var step = parseInt(root.getAttribute('data-rv-step') || '6', 10);
        var topic = '';
        var shown = step;

        var paint = function () {
          var matched = cards.filter(function (c) {
            return topic === '' || c.getAttribute('data-topic') === topic;
          });
          cards.forEach(function (c) {
            c.hidden = true;
          });
          matched.slice(0, shown).forEach(function (c) {
            c.hidden = false;
          });
          if (none) {
            none.hidden = matched.length > 0;
          }
          if (more) {
            more.hidden = matched.length <= shown;
          }
        };

        chips.forEach(function (ch) {
          ch.addEventListener('click', function () {
            topic = ch.getAttribute('data-topic');
            shown = step;
            chips.forEach(function (o) {
              var on = o === ch;
              o.classList.toggle('is-on', on);
              o.setAttribute('aria-pressed', on ? 'true' : 'false');
            });
            paint();
          });
        });
        if (more) {
          more.addEventListener('click', function () {
            shown += step;
            paint();
          });
        }
        paint();
      }
    }
    function scan(ctx) {
      var scope = ctx && ctx.querySelectorAll ? ctx : document;
      [].forEach.call(scope.querySelectorAll('[data-dc-rv]'), init);
      if (scope !== document && scope.matches && scope.matches('[data-dc-rv]')) init(scope);
    }
    scan(document);
    document.addEventListener('shopify:section:load', function (e) {
      scan(e.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dd-buy-box"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';
  function init(root) {
    if (root.dataset.ddReady === '1') return;
    root.dataset.ddReady = '1';
    var gal = root.querySelector('[data-dd-gal]');
    var thumbs = [].slice.call(root.querySelectorAll('.thumb'));
    var wrapEl = root.closest('.dd') || document;

    /* ── Gallery ─────────────────────────────────────────────────────── */
    if (gal) {
      var slides = [].slice.call(gal.querySelectorAll('.gslide'));
      var count = gal.querySelector('.gcount b');
      var at = 0;

      var show = function (i) {
        at = (i + slides.length) % slides.length;
        slides.forEach(function (s, n) { s.classList.toggle('is-on', n === at); });
        thumbs.forEach(function (t, n) {
          t.classList.toggle('is-on', n === at);
          if (n === at) { t.setAttribute('aria-current', 'true'); } else { t.removeAttribute('aria-current'); }
        });
        if (count) { count.textContent = String(at + 1); }
      };

      thumbs.forEach(function (t) {
        t.addEventListener('click', function () { show(+t.dataset.i); });
      });
      var prev = gal.querySelector('.gnav--prev');
      var next = gal.querySelector('.gnav--next');
      if (prev) { prev.addEventListener('click', function () { show(at - 1); }); }
      if (next) { next.addEventListener('click', function () { show(at + 1); }); }

      /* Arrow keys, but only while the gallery has focus — hijacking them
         for the whole document is how a page becomes unusable. */
      var galWrap = root.querySelector('.gal');
      if (galWrap) {
        galWrap.addEventListener('keydown', function (e) {
          if (e.key === 'ArrowRight') { show(at + 1); e.preventDefault(); }
          if (e.key === 'ArrowLeft') { show(at - 1); e.preventDefault(); }
        });
      }

      /* Swipe, because most of this traffic is a thumb on a phone. */
      var x0 = null;
      gal.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
      gal.addEventListener('touchend', function (e) {
        if (x0 === null) { return; }
        var dx = e.changedTouches[0].clientX - x0;
        if (Math.abs(dx) > 44) { show(at + (dx < 0 ? 1 : -1)); }
        x0 = null;
      }, { passive: true });
    }

    /* ── Price ───────────────────────────────────────────────────────────
       Copy, never compute. Every string below was produced by Shopify's
       money filter in Liquid; this only decides which one is showing. */
    var rows = [].slice.call(root.querySelectorAll('input[name=quantity]'));
    var setAll = function (sel, value) {
      [].forEach.call(wrapEl.querySelectorAll(sel), function (e) { e.textContent = value; });
    };

    var paint = function () {
      var sel = rows.filter(function (r) { return r.checked; })[0] || rows[0];
      if (!sel) { return; }
      var d = sel.dataset;

      setAll('[data-price-now]', d.total);
      setAll('[data-echo-pack]', d.label);
      setAll('[data-per-treatment]', d.per);

      var hasCompare = +d.hasCompare > 0;
      [].forEach.call(wrapEl.querySelectorAll('[data-price-was]'), function (e) {
        e.hidden = !hasCompare;
        e.textContent = d.compare;
      });
      [].forEach.call(wrapEl.querySelectorAll('[data-price-save]'), function (e) {
        var pct = +d.save;
        e.hidden = !(hasCompare && pct > 0);
        e.textContent = (e.dataset.word || '') + ' ' + pct + '%';
      });

      rows.forEach(function (r) {
        var row = r.closest('.pack');
        if (row) { row.classList.toggle('is-on', r.checked); }
      });
    };

    rows.forEach(function (r) { r.addEventListener('change', paint); });
    paint();

    /* ── The picker ──────────────────────────────────────────────────────
       The input IS the line item property, so there is nothing to copy into
       a hidden field. This only keeps the swatch row's label in step with
       what is selected. */
    var picks = [].slice.call(root.querySelectorAll('input[data-dd-pick]'));
    var echo = root.querySelector('[data-dd-pick-echo]');
    if (picks.length) {
      var paintPick = function () {
        picks.forEach(function (p) {
          var l = p.closest('.psw') || p.closest('.pcard');
          if (l) { l.classList.toggle('is-on', p.checked); }
        });
        var on = picks.filter(function (p) { return p.checked; })[0];
        if (echo && on) { echo.textContent = on.dataset.label || on.value; }
      };
      picks.forEach(function (p) { p.addEventListener('change', paintPick); });
      paintPick();
    }

    /* ── Delivery estimate ───────────────────────────────────────────────
       Worked out from today in the browser rather than typed into the page,
       so it cannot go stale, and worded as an estimate because that is what
       it is. The two bounds are settings on the shipping block. */
    var ship = root.querySelector('.ship');
    if (ship) {
      var out = ship.querySelector('[data-eta]');
      var lo = new Date(); lo.setDate(lo.getDate() + (+ship.dataset.etaMin || 4));
      var hi = new Date(); hi.setDate(hi.getDate() + (+ship.dataset.etaMax || 7));
      var fmt = function (d) { return d.toLocaleDateString(document.documentElement.lang || 'en', { weekday: 'short', month: 'short', day: 'numeric' }); };
      if (out) { out.textContent = fmt(lo) + ' – ' + fmt(hi); }
    }

    /* ── Sticky bar ──────────────────────────────────────────────────────
       The rootMargin is the whole trick. An IntersectionObserver only calls
       back when the ratio CROSSES a threshold. With a plain viewport root
       the button starts below the fold at ratio 0, and a jump to the footer
       leaves it above the fold at ratio 0 — nothing crossed, nothing fires,
       the bar never appears. Extending the root a million pixels DOWNWARD
       makes "still here or still below" a real 0-to-1 crossing. */
    var bar = wrapEl.querySelector('[data-dd-sticky]');
    var anchor = root.querySelector('.atc');
    if (bar && anchor && 'IntersectionObserver' in window) {
      bar.hidden = false;
      new IntersectionObserver(function (entries) {
        var last = entries[entries.length - 1];
        bar.classList.toggle('is-up', !last.isIntersecting);
      }, { threshold: 0, rootMargin: '0px 0px 999999px 0px' }).observe(anchor);
    }
  }
  function scan(ctx) {
    var scope = ctx && ctx.querySelectorAll ? ctx : document;
    [].forEach.call(scope.querySelectorAll('[data-dd-buy]'), init);
    if (scope !== document && scope.matches && scope.matches('[data-dd-buy]')) init(scope);
  }
  scan(document);
  document.addEventListener('shopify:section:load', function (e) { scan(e.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dd-faq"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';
  function init(root) {
    if (root.dataset.ddReady === '1') return;
    root.dataset.ddReady = '1';
    var all = [].slice.call(root.querySelectorAll('details'));
    if (!all.length) { return; }

    /* Everything here is an enhancement. With the script blocked the details
       elements still open — they just all stay open. */
    all.forEach(function (d) {
      d.addEventListener('toggle', function () {
        if (!d.open) { return; }
        all.forEach(function (o) { if (o !== d) { o.open = false; } });
      });
    });
  }
  function scan(ctx) {
    var scope = ctx && ctx.querySelectorAll ? ctx : document;
    [].forEach.call(scope.querySelectorAll('[data-dd-faq]'), init);
    if (scope !== document && scope.matches && scope.matches('[data-dd-faq]')) init(scope);
  }
  scan(document);
  document.addEventListener('shopify:section:load', function (e) { scan(e.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dd-foryou"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';
  function init(root) {
    if (root.dataset.ddReady === '1') return;
    root.dataset.ddReady = '1';
    var boxes = [].slice.call(root.querySelectorAll('[data-fit-q]'));
    var out = root.querySelector('[data-fit-out]');
    var cta = root.querySelector('[data-fit-cta]');
    if (!boxes.length || !out) { return; }

    var MSG = {
      none: root.dataset.msgNone || '',
      no: root.dataset.msgNo || '',
      maybe: root.dataset.msgMaybe || '',
      yes: root.dataset.msgYes || ''
    };

    var paint = function () {
      var answered = boxes.filter(function (b) { return b.checked; });
      var blockers = boxes.filter(function (b) { return !b.checked && b.dataset.fitStop === 'true'; });
      var soft = boxes.filter(function (b) { return !b.checked && b.dataset.fitStop !== 'true'; });
      var reasons = function (list) {
        return list.map(function (b) { return b.dataset.fitNo || ''; }).filter(Boolean).join(' ');
      };

      var state = !answered.length ? 'none' : (blockers.length ? 'no' : (soft.length ? 'maybe' : 'yes'));
      root.dataset.fitState = state;

      if (state === 'none') { out.innerHTML = MSG.none; }
      else if (state === 'no') { out.innerHTML = MSG.no + ' ' + reasons(blockers); }
      else if (state === 'maybe') { out.innerHTML = MSG.maybe + ' ' + reasons(soft); }
      else { out.innerHTML = MSG.yes; }

      /* The buy link is hidden on a hard miss. That is the section doing its
         job: a page that keeps selling after it has told you not to buy has
         wasted the only sentence anyone was going to believe. */
      if (cta) { cta.hidden = (state === 'none' || state === 'no'); }

      boxes.forEach(function (b) {
        var l = b.closest('.fit__o');
        if (l) { l.classList.toggle('is-on', b.checked); }
      });
    };

    boxes.forEach(function (b) { b.addEventListener('change', paint); });
    paint();
  }
  function scan(ctx) {
    var scope = ctx && ctx.querySelectorAll ? ctx : document;
    [].forEach.call(scope.querySelectorAll('[data-dd-fit]'), init);
    if (scope !== document && scope.matches && scope.matches('[data-dd-fit]')) init(scope);
  }
  scan(document);
  document.addEventListener('shopify:section:load', function (e) { scan(e.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dd-how"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';
  function init(root) {
    if (root.dataset.ddReady === '1') return;
    root.dataset.ddReady = '1';
    var dots = [].slice.call(root.querySelectorAll('[data-step]'));
    var panels = [].slice.call(root.querySelectorAll('[data-step-panel]'));
    var prev = root.querySelector('[data-step-prev]');
    var next = root.querySelector('[data-step-next]');
    if (!panels.length) { return; }
    var at = 0;

    var show = function (i) {
      at = Math.max(0, Math.min(panels.length - 1, i));
      dots.forEach(function (d, n) {
        d.classList.toggle('is-on', n === at);
        d.classList.toggle('is-done', n < at);
        d.setAttribute('aria-current', n === at ? 'step' : 'false');
      });
      panels.forEach(function (p, n) { p.hidden = n !== at; });
      if (prev) { prev.disabled = at === 0; }
      if (next) { next.disabled = at === panels.length - 1; }
    };

    root.addEventListener('click', function (e) {
      var d = e.target.closest('[data-step]');
      if (d) { show(dots.indexOf(d)); return; }
      if (e.target.closest('[data-step-prev]')) { show(at - 1); }
      if (e.target.closest('[data-step-next]')) { show(at + 1); }
    });

    show(0);
  }
  function scan(ctx) {
    var scope = ctx && ctx.querySelectorAll ? ctx : document;
    [].forEach.call(scope.querySelectorAll('[data-dd-steps]'), init);
    if (scope !== document && scope.matches && scope.matches('[data-dd-steps]')) init(scope);
  }
  scan(document);
  document.addEventListener('shopify:section:load', function (e) { scan(e.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dd-lasts"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';
  function init(root) {
    if (root.dataset.ddReady === '1') return;
    root.dataset.ddReady = '1';
    var boxes = [].slice.call(root.querySelectorAll('[data-last-box]'));
    var freqs = [].slice.call(root.querySelectorAll('[data-last-freq]'));
    var outT = root.querySelector('[data-last-treatments]');
    var outW = root.querySelector('[data-last-weeks]');
    var outD = root.querySelector('[data-last-date]');
    var outL = root.querySelector('[data-last-line]');
    if (!boxes.length || !freqs.length) { return; }

    /* The only inputs, and both are published figures carried in on the root:
       strips in a box, and strips to a treatment. Everything else is
       division — which is exactly why this can be shown rather than claimed. */
    var STRIPS = +root.dataset.strips || 42;
    var PER = +root.dataset.per || 2;
    var TREATMENTS = Math.floor(STRIPS / PER);
    var WEEK = root.dataset.weekWord || 'weeks';
    var MONTH = root.dataset.monthWord || 'months';
    var TPL = root.dataset.tpl || '';

    var trim = function (n) { return String(n).replace(/\.0$/, ''); };

    var paint = function () {
      var b = boxes.filter(function (i) { return i.checked; })[0] || boxes[0];
      var f = freqs.filter(function (i) { return i.checked; })[0] || freqs[0];
      var n = +b.value || 1;
      var perWeek = parseFloat(f.dataset.lastFreq) || 7;

      var total = TREATMENTS * n;
      var weeks = total / perWeek;
      var days = Math.round(weeks * 7);

      if (outT) { outT.textContent = total; }
      if (outW) {
        outW.textContent = weeks >= 8
          ? trim((weeks / 4.345).toFixed(1)) + ' ' + MONTH
          : trim((Math.round(weeks * 10) / 10).toFixed(1)) + ' ' + WEEK;
      }

      /* Worked out from today in the browser, so it cannot go stale. */
      var end = new Date();
      end.setDate(end.getDate() + days);
      var dateText = end.toLocaleDateString(document.documentElement.lang || 'en', { month: 'long', day: 'numeric', year: 'numeric' });
      if (outD) { outD.textContent = dateText; }

      if (outL) {
        outL.innerHTML = TPL
          .replace('{boxes}', '<b>' + (b.dataset.lastLabel || n) + '</b>')
          .replace('{treatments}', '<b>' + total + '</b>')
          .replace('{per}', PER)
          .replace('{freq}', f.dataset.lastLabel || '');
      }

      boxes.concat(freqs).forEach(function (i) {
        var l = i.closest('.lopt');
        if (l) { l.classList.toggle('is-on', i.checked); }
      });
    };

    boxes.concat(freqs).forEach(function (i) { i.addEventListener('change', paint); });
    paint();
  }
  function scan(ctx) {
    var scope = ctx && ctx.querySelectorAll ? ctx : document;
    [].forEach.call(scope.querySelectorAll('[data-dd-lasts]'), init);
    if (scope !== document && scope.matches && scope.matches('[data-dd-lasts]')) init(scope);
  }
  scan(document);
  document.addEventListener('shopify:section:load', function (e) { scan(e.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dd-review"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';
  function init(root) {
    if (root.dataset.ddReady === '1') return;
    root.dataset.ddReady = '1';
    var chips = [].slice.call(root.querySelectorAll('[data-chip]'));
    var cards = [].slice.call(root.querySelectorAll('.rv'));
    var count = root.querySelector('[data-rv-count]');
    var more  = root.querySelector('[data-rv-more]');
    var empty = root.querySelector('[data-rv-empty]');
    if (!cards.length) { return; }

    var FOLD = +root.dataset.fold || 6;
    var TPL_SOME = root.dataset.tplSome || 'Showing {n} of {all}';
    var TPL_ALL = root.dataset.tplAll || 'Showing all {all}';
    var CRIT = +root.dataset.criticalAt || 3;
    var open = false;

    cards.forEach(function (c, i) { if (i >= FOLD) { c.setAttribute('data-more', ''); } });

    var paint = function (topic) {
      /* Count what is on screen, not what matched. Those are different
         numbers while the wall is folded, and a counter that says "all 12"
         over six visible cards is the page contradicting itself. */
      var shown = 0;
      cards.forEach(function (c) {
        var match = topic === 'all' ||
          (topic === 'critical' ? +c.dataset.stars <= CRIT : c.dataset.topic === topic);
        /* Folding only applies while the wall is unfiltered. Once you have
           asked for one topic, hiding half the answer is just rude. */
        var folded = !open && topic === 'all' && c.hasAttribute('data-more');
        c.hidden = !match || folded;
        if (!c.hidden) { shown++; }
      });
      if (count) {
        count.textContent = (shown === cards.length ? TPL_ALL : TPL_SOME)
          .replace('{n}', shown).replace('{all}', cards.length);
      }
      if (empty) { empty.hidden = shown > 0; }
      if (more) { more.hidden = open || topic !== 'all' || cards.length <= FOLD; }
    };

    root.addEventListener('click', function (e) {
      var chip = e.target.closest('[data-chip]');
      if (chip) {
        chips.forEach(function (c) {
          var on = c === chip;
          c.classList.toggle('is-on', on);
          c.setAttribute('aria-pressed', on ? 'true' : 'false');
        });
        paint(chip.dataset.chip);
        return;
      }
      if (e.target.closest('[data-rv-more]')) {
        open = true;
        var active = chips.filter(function (c) { return c.classList.contains('is-on'); })[0];
        paint(active ? active.dataset.chip : 'all');
      }
    });

    paint('all');
  }
  function scan(ctx) {
    var scope = ctx && ctx.querySelectorAll ? ctx : document;
    [].forEach.call(scope.querySelectorAll('[data-dd-reviews]'), init);
    if (scope !== document && scope.matches && scope.matches('[data-dd-reviews]')) init(scope);
  }
  scan(document);
  document.addEventListener('shopify:section:load', function (e) { scan(e.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dd-why"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';
  function init(root) {
    if (root.dataset.ddReady === '1') return;
    root.dataset.ddReady = '1';
    var range = root.querySelector('[data-why-range]');
    var tooth = root.querySelector('[data-why-tooth]');
    var film  = root.querySelector('[data-why-film]');
    var pct   = root.querySelector('[data-why-pct]');
    var note  = root.querySelector('[data-why-note]');
    if (!range || !tooth) { return; }

    /* Both ends are real colours and both are settings, so the demonstration
       can be retuned in the editor. Everything between is interpolated —
       the point is that purple CANCELS yellow rather than removing it, and
       an interpolation shows that where a two-image swap would not. */
    var parse = function (hex, fallback) {
      var m = /^#?([0-9a-f]{6})$/i.exec((hex || '').trim());
      if (!m) { return fallback; }
      var n = parseInt(m[1], 16);
      return [(n >> 16) & 255, (n >> 8) & 255, n & 255];
    };
    var FROM = parse(root.dataset.from, [232, 214, 150]);
    var TO   = parse(root.dataset.to, [246, 243, 238]);
    var notes = [root.dataset.note0 || '', root.dataset.note1 || '', root.dataset.note2 || ''];
    var maxFilm = (parseFloat(root.dataset.filmMax) || 55) / 100;

    var paint = function () {
      var t = (+range.value || 0) / 100;
      var c = FROM.map(function (v, i) { return Math.round(v + (TO[i] - v) * t); });
      tooth.style.background = 'rgb(' + c.join(',') + ')';
      if (film) { film.style.opacity = (t * maxFilm).toFixed(2); }
      if (pct) { pct.textContent = Math.round(t * 100) + '%'; }
      if (note) { note.textContent = t === 0 ? notes[0] : (t < 0.5 ? notes[1] : notes[2]); }
    };

    range.addEventListener('input', paint);
    paint();
  }
  function scan(ctx) {
    var scope = ctx && ctx.querySelectorAll ? ctx : document;
    [].forEach.call(scope.querySelectorAll('[data-dd-why]'), init);
    if (scope !== document && scope.matches && scope.matches('[data-dd-why]')) init(scope);
  }
  scan(document);
  document.addEventListener('shopify:section:load', function (e) { scan(e.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kh-buybox"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';
  function init(root) {
    if (root.dataset.khReady === '1') return;
    root.dataset.khReady = '1';
    var gal = root.querySelector('[data-kh-gal]');
    var wrapEl = root.closest('.kh') || document;
    var setAll = function (sel, value) {
      [].forEach.call(wrapEl.querySelectorAll(sel), function (e) { e.textContent = value; });
    };
    if (gal) {
      var slides = [].slice.call(gal.querySelectorAll('.gal__f'));
      var thumbs = [].slice.call(gal.querySelectorAll('.gal__t'));
      var count = gal.querySelector('.gal__ct b');
      var total = gal.querySelector('[data-gal-total]');
      var at = 0;
      if (total) { total.textContent = String(slides.length); }
      var show = function (i) {
        if (!slides.length) { return; }
        at = (i + slides.length) % slides.length;
        slides.forEach(function (s, n) {
          s.classList.toggle('is-on', n === at);
          if (n === at) { s.removeAttribute('aria-hidden'); } else { s.setAttribute('aria-hidden', 'true'); }
        });
        thumbs.forEach(function (t, n) { t.classList.toggle('is-on', n === at); t.setAttribute('aria-selected', n === at ? 'true' : 'false'); });
        if (count) { count.textContent = String(at + 1); }
      };
      thumbs.forEach(function (t) { t.addEventListener('click', function () { show(+t.getAttribute('data-i')); }); });
      var prev = gal.querySelector('.gal__nav--p'), next = gal.querySelector('.gal__nav--n');
      if (prev) { prev.addEventListener('click', function () { show(at - 1); }); }
      if (next) { next.addEventListener('click', function () { show(at + 1); }); }
      gal.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight') { show(at + 1); e.preventDefault(); }
        if (e.key === 'ArrowLeft') { show(at - 1); e.preventDefault(); }
      });
      var x0 = null, y0 = null;
      gal.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; y0 = e.touches[0].clientY; }, { passive: true });
      gal.addEventListener('touchend', function (e) {
        if (x0 === null) { return; }
        var dx = e.changedTouches[0].clientX - x0, dy = e.changedTouches[0].clientY - y0;
        if (Math.abs(dx) > 44 && Math.abs(dx) > Math.abs(dy)) { show(at + (dx < 0 ? 1 : -1)); }
        x0 = null; y0 = null;
      }, { passive: true });
    }

    /* The variant: every string was produced by Liquid's money filter and
       parked on the radio. Nothing here parses or multiplies a price. */
    var variants = [].slice.call(root.querySelectorAll('input[name=id][type=radio]'));
    var paint = function () {
      var on = variants.filter(function (v) { return v.checked; })[0];
      if (!on) { return; }
      setAll('[data-price-now]', on.getAttribute('data-price'));
      setAll('[data-echo]', on.getAttribute('data-title'));
      var hasCmp = on.getAttribute('data-has-cmp') === '1';
      [].forEach.call(wrapEl.querySelectorAll('[data-price-was]'), function (e) {
        e.hidden = !hasCmp;
        if (hasCmp) { e.textContent = on.getAttribute('data-cmp'); }
      });
    };
    variants.forEach(function (v) { v.addEventListener('change', paint); });

    var q = root.querySelector('[data-qty]');
    if (q) {
      var clamp = function (n) { return Math.max(1, Math.min(99, isNaN(n) ? 1 : n)); };
      var step = function (d) { q.value = clamp(parseInt(q.value, 10) + d); };
      var mi = root.querySelector('[data-minus]'), pl = root.querySelector('[data-plus]');
      if (mi) { mi.addEventListener('click', function () { step(-1); }); }
      if (pl) { pl.addEventListener('click', function () { step(1); }); }
      q.addEventListener('change', function () { q.value = clamp(parseInt(q.value, 10)); });
    }

    /* A scroll listener rather than an IntersectionObserver: an observer
       misses an instant jump past the button, and the bar never appears. */
    var stk = wrapEl.querySelector('[data-kh-sticky]');
    var anchor = root.querySelector('.bb__buy');
    if (stk && anchor) {
      var queued = false;
      var sync = function () { queued = false; stk.hidden = anchor.getBoundingClientRect().bottom > 0; };
      var onMove = function () {
        if (queued) { return; }
        queued = true;
        if (window.requestAnimationFrame) { window.requestAnimationFrame(sync); } else { setTimeout(sync, 16); }
      };
      window.addEventListener('scroll', onMove, { passive: true });
      window.addEventListener('resize', onMove);
      sync();
    }
  }
  function scan(ctx) {
    var scope = ctx && ctx.querySelectorAll ? ctx : document;
    [].forEach.call(scope.querySelectorAll('[data-kh-buy]'), init);
    if (scope !== document && scope.matches && scope.matches('[data-kh-buy]')) init(scope);
  }
  scan(document);
  document.addEventListener('shopify:section:load', function (e) { scan(e.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kh-review"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';
  function init(root) {
    if (root.dataset.khReady === '1') return;
    root.dataset.khReady = '1';
    var grid = root.querySelector('[data-rv-grid]');
    if (grid) {
      var cards = [].slice.call(grid.querySelectorAll('.rv__c'));
      var chips = [].slice.call(root.querySelectorAll('.rv__ch'));
      var more = root.querySelector('[data-rv-more]');
      var none = root.querySelector('[data-rv-none]');
      var step = 6;
      var topic = '';
      var shown = step;

      var paint = function () {
        var matched = cards.filter(function (c) {
          return topic === '' || c.getAttribute('data-topic') === topic;
        });
        cards.forEach(function (c) { c.hidden = true; });
        matched.slice(0, shown).forEach(function (c) { c.hidden = false; });
        if (none) { none.hidden = matched.length > 0; }
        if (more) { more.hidden = matched.length <= shown; }
      };

      chips.forEach(function (ch) {
        ch.addEventListener('click', function () {
          topic = ch.getAttribute('data-topic');
          shown = step;
          chips.forEach(function (o) {
            var on = o === ch;
            o.classList.toggle('is-on', on);
            o.setAttribute('aria-pressed', on ? 'true' : 'false');
          });
          paint();
        });
      });
      if (more) { more.addEventListener('click', function () { shown += step; paint(); }); }
      paint();
    }
  }
  function scan(ctx) {
    var scope = ctx && ctx.querySelectorAll ? ctx : document;
    [].forEach.call(scope.querySelectorAll('[data-kh-rv]'), init);
    if (scope !== document && scope.matches && scope.matches('[data-kh-rv]')) init(scope);
  }
  scan(document);
  document.addEventListener('shopify:section:load', function (e) { scan(e.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mp-buybox"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';
  function init(root) {
    if (root.dataset.mpReady === '1') return;
    root.dataset.mpReady = '1';
    var gal = root.querySelector('[data-mp-gal]');
    var wrapEl = root.closest('.mp') || document;

    /* ── Gallery ─────────────────────────────────────────────────────── */
    if (gal) {
      var slides = [].slice.call(gal.querySelectorAll('.gslide'));
      var thumbs = [].slice.call(gal.querySelectorAll('.thumb'));
      var count = gal.querySelector('.gcount b');
      var total = gal.querySelector('[data-gal-total]');
      var at = 0;
      if (total) { total.textContent = String(slides.length); }

      var show = function (i) {
        at = (i + slides.length) % slides.length;
        slides.forEach(function (s, n) { s.classList.toggle('is-on', n === at); });
        thumbs.forEach(function (t, n) {
          t.classList.toggle('is-on', n === at);
          if (n === at) { t.setAttribute('aria-current', 'true'); } else { t.removeAttribute('aria-current'); }
        });
        if (count) { count.textContent = String(at + 1); }
      };

      thumbs.forEach(function (t) {
        t.addEventListener('click', function () { show(+t.getAttribute('data-i')); });
      });
      var prev = gal.querySelector('.gnav--prev');
      var next = gal.querySelector('.gnav--next');
      if (prev) { prev.addEventListener('click', function () { show(at - 1); }); }
      if (next) { next.addEventListener('click', function () { show(at + 1); }); }

      /* Arrow keys, but only while the gallery has focus — hijacking them
         for the whole document is how a page becomes unusable. */
      gal.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight') { show(at + 1); e.preventDefault(); }
        if (e.key === 'ArrowLeft') { show(at - 1); e.preventDefault(); }
      });

      /* Swipe, because most of this traffic is a thumb on a phone. */
      var x0 = null;
      gal.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
      gal.addEventListener('touchend', function (e) {
        if (x0 === null) { return; }
        var dx = e.changedTouches[0].clientX - x0;
        if (Math.abs(dx) > 44) { show(at + (dx < 0 ? 1 : -1)); }
        x0 = null;
      }, { passive: true });
    }

    /* ── Variant and quantity ────────────────────────────────────────────
       Two radio groups, and every combination of the two was worked out in
       Liquid. This looks up the attribute for the selected variant; it does
       not multiply. */
    var versions = [].slice.call(root.querySelectorAll('input[name=id]'));
    var rows = [].slice.call(root.querySelectorAll('input[name=quantity]'));
    var setAll = function (sel, value) {
      [].forEach.call(wrapEl.querySelectorAll(sel), function (e) { e.textContent = value; });
    };

    var currentVariant = function () {
      var on = versions.filter(function (v) { return v.checked; })[0];
      if (on) { return on.getAttribute('data-vid') || on.value; }
      return versions.length ? (versions[0].getAttribute('data-vid') || versions[0].value) : '';
    };

    var paint = function () {
      var vid = currentVariant();
      var sel = rows.filter(function (r) { return r.checked; })[0] || rows[0];
      if (!sel || !vid) { return; }

      var get = function (el, key) { return el.getAttribute('data-' + key + '-' + vid) || ''; };

      /* every row reprices itself for the variant now selected */
      rows.forEach(function (r) {
        var row = r.closest('.pack');
        if (!row) { return; }
        row.classList.toggle('is-on', r.checked);
        var totalEl = row.querySelector('[data-pack-total]');
        var eachEl = row.querySelector('[data-pack-each]');
        if (totalEl) { totalEl.textContent = get(r, 'total'); }
        if (eachEl && eachEl.getAttribute('data-one') !== '1') {
          var each = get(r, 'each');
          if (each && +r.value > 1) { eachEl.textContent = each + ' ' + (eachEl.getAttribute('data-word') || ''); }
        }
      });

      setAll('[data-price-now]', get(sel, 'total'));
      setAll('[data-echo-pack]', sel.getAttribute('data-label') || '');

      var onV = versions.filter(function (v) { return v.checked; })[0];
      if (onV) { setAll('[data-echo-version]', onV.getAttribute('data-title') || ''); }

      var hasCmp = +get(sel, 'has-cmp') > 0;
      [].forEach.call(wrapEl.querySelectorAll('[data-price-was]'), function (e) {
        e.hidden = !hasCmp;
        e.textContent = get(sel, 'cmp');
      });
      [].forEach.call(wrapEl.querySelectorAll('[data-price-save]'), function (e) {
        var pct = +get(sel, 'save');
        e.hidden = !(hasCmp && pct > 0);
        e.textContent = (e.getAttribute('data-word') || '') + ' ' + pct + '%';
      });

      versions.forEach(function (v) {
        var l = v.closest('.vopt');
        if (l) { l.classList.toggle('is-on', v.checked); }
      });
    };

    versions.concat(rows).forEach(function (i) { i.addEventListener('change', paint); });
    paint();

    /* ── The picker ──────────────────────────────────────────────────────
       The input IS the line item property, so there is nothing to copy
       into a hidden field. This only keeps the swatch row's label in step. */
    var picks = [].slice.call(root.querySelectorAll('input[data-mp-pick]'));
    var echo = root.querySelector('[data-mp-pick-echo]');
    if (picks.length) {
      var paintPick = function () {
        picks.forEach(function (p) {
          var l = p.closest('.psw') || p.closest('.pcard');
          if (l) { l.classList.toggle('is-on', p.checked); }
        });
        var on = picks.filter(function (p) { return p.checked; })[0];
        if (echo && on) { echo.textContent = on.getAttribute('data-label') || on.value; }
      };
      picks.forEach(function (p) { p.addEventListener('change', paintPick); });
      paintPick();
    }

    /* ── Delivery estimate ───────────────────────────────────────────────
       Worked out from today in the browser rather than typed into the page,
       so it cannot go stale, and worded as an estimate because that is what
       it is. The two bounds are settings on the shipping block. */
    var ship = root.querySelector('.ship');
    if (ship) {
      var out = ship.querySelector('[data-eta]');
      var lo = new Date(); lo.setDate(lo.getDate() + (+ship.getAttribute('data-eta-min') || 3));
      var hi = new Date(); hi.setDate(hi.getDate() + (+ship.getAttribute('data-eta-max') || 6));
      var fmt = function (d) { return d.toLocaleDateString(document.documentElement.lang || 'en', { weekday: 'short', month: 'short', day: 'numeric' }); };
      if (out) { out.textContent = fmt(lo) + ' \u2013 ' + fmt(hi); }
    }

    /* ── Sticky bar ──────────────────────────────────────────────────────
       The rootMargin is the whole trick. An IntersectionObserver only calls
       back when the ratio CROSSES a threshold. With a plain viewport root
       the button starts below the fold at ratio 0, and a jump to the footer
       leaves it above the fold at ratio 0 — nothing crossed, nothing fires,
       the bar never appears. Extending the root a million pixels DOWNWARD
       makes "still here or still below" a real 0-to-1 crossing. */
    var bar = wrapEl.querySelector('[data-mp-sticky]');
    var anchor = root.querySelector('.atc');
    if (bar && anchor && 'IntersectionObserver' in window) {
      bar.hidden = false;
      new IntersectionObserver(function (entries) {
        var last = entries[entries.length - 1];
        bar.classList.toggle('is-up', !last.isIntersecting);
      }, { threshold: 0, rootMargin: '0px 0px 999999px 0px' }).observe(anchor);
    }
  }
  function scan(ctx) {
    var scope = ctx && ctx.querySelectorAll ? ctx : document;
    [].forEach.call(scope.querySelectorAll('[data-mp-buy]'), init);
    if (scope !== document && scope.matches && scope.matches('[data-mp-buy]')) init(scope);
  }
  scan(document);
  document.addEventListener('shopify:section:load', function (e) { scan(e.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mp-faces"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';
  function init(root) {
    if (root.dataset.mpReady === '1') return;
    root.dataset.mpReady = '1';
    var tabs = [].slice.call(root.querySelectorAll('[role="tab"]'));
    var panels = [].slice.call(root.querySelectorAll('[role="tabpanel"]'));
    var label = root.querySelector('[data-flip-label]');
    if (!tabs.length) { return; }
    var keys = tabs.map(function (t) { return t.getAttribute('data-face-tab'); });

    var select = function (key, focus) {
      root.setAttribute('data-face', key);
      tabs.forEach(function (t) {
        var on = t.getAttribute('data-face-tab') === key;
        t.setAttribute('aria-selected', on ? 'true' : 'false');
        t.tabIndex = on ? 0 : -1;
        if (on && focus) { t.focus(); }
      });
      panels.forEach(function (p) { p.hidden = p.getAttribute('data-face-panel') !== key; });
      /* The button says what it will do next, not what just happened. */
      if (label) {
        var other = keys[(keys.indexOf(key) + 1) % keys.length];
        var tab = tabs.filter(function (t) { return t.getAttribute('data-face-tab') === other; })[0];
        label.textContent = tab
          ? (root.getAttribute('data-flip-word') || 'Show the') + ' ' + tab.textContent.trim().toLowerCase()
          : (root.getAttribute('data-flip-fallback') || 'Turn it over');
      }
    };

    root.addEventListener('click', function (e) {
      var t = e.target.closest('[role="tab"]');
      if (t) { select(t.getAttribute('data-face-tab')); return; }
      if (e.target.closest('[data-flip]')) {
        select(keys[(keys.indexOf(root.getAttribute('data-face')) + 1) % keys.length]);
      }
    });

    /* A tablist that does not answer the arrow keys is a row of buttons
       wearing a tablist's clothes. */
    root.addEventListener('keydown', function (e) {
      var t = e.target.closest('[role="tab"]');
      if (!t) { return; }
      var i = tabs.indexOf(t), n = null;
      if (e.key === 'ArrowRight') { n = (i + 1) % tabs.length; }
      else if (e.key === 'ArrowLeft') { n = (i - 1 + tabs.length) % tabs.length; }
      else if (e.key === 'Home') { n = 0; }
      else if (e.key === 'End') { n = tabs.length - 1; }
      if (n === null) { return; }
      e.preventDefault();
      select(tabs[n].getAttribute('data-face-tab'), true);
    });

    select(keys[0]);
  }
  function scan(ctx) {
    var scope = ctx && ctx.querySelectorAll ? ctx : document;
    [].forEach.call(scope.querySelectorAll('[data-mp-faces]'), init);
    if (scope !== document && scope.matches && scope.matches('[data-mp-faces]')) init(scope);
  }
  scan(document);
  document.addEventListener('shopify:section:load', function (e) { scan(e.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mp-faq"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';
  function init(root) {
    if (root.dataset.mpReady === '1') return;
    root.dataset.mpReady = '1';
    var all = [].slice.call(root.querySelectorAll('details'));
    if (all.length < 2) { return; }
    if (root.getAttribute('data-solo') !== 'true') { return; }

    /* Everything here is an enhancement. With the script gone the details
       elements still open — they just all stay open at once. */
    all.forEach(function (d) {
      d.addEventListener('toggle', function () {
        if (!d.open) { return; }
        all.forEach(function (o) { if (o !== d) { o.open = false; } });
      });
    });
  }
  function scan(ctx) {
    var scope = ctx && ctx.querySelectorAll ? ctx : document;
    [].forEach.call(scope.querySelectorAll('[data-mp-faq]'), init);
    if (scope !== document && scope.matches && scope.matches('[data-mp-faq]')) init(scope);
  }
  scan(document);
  document.addEventListener('shopify:section:load', function (e) { scan(e.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mp-reach"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';
  function init(root) {
    if (root.dataset.mpReady === '1') return;
    root.dataset.mpReady = '1';
    var range = root.querySelector('[data-reach-range]');
    var val = root.querySelector('[data-reach-val]');
    var span = root.querySelector('[data-reach-span]');
    var need = root.querySelector('[data-reach-need]');
    var head = root.querySelector('[data-reach-head]');
    var out = root.querySelector('[data-reach-out]');
    var haveBar = root.querySelector('[data-reach-have]');
    var needBar = root.querySelector('[data-reach-needbar]');
    var units = [].slice.call(root.querySelectorAll('[data-reach-unit]'));
    if (!range || !val || !out || !head) { return; }

    /* Every number here is a setting, carried in on a data- attribute. The
       script converts and subtracts; it invents nothing. */
    var STRAP_CM = parseFloat(root.getAttribute('data-strap-cm')) || 68.2;
    var GRIP_CM = parseFloat(root.getAttribute('data-grip-cm')) || 9;
    var SHARE = (parseFloat(root.getAttribute('data-share')) || 27) / 100;
    var ROOM = parseFloat(root.getAttribute('data-room-cm')) || 6;
    var unit = 'in';

    var fmt = function (cm) {
      return unit === 'cm'
        ? cm.toFixed(0) + ' ' + (root.getAttribute('data-unit-cm') || 'cm')
        : (cm / 2.54).toFixed(1) + ' ' + (root.getAttribute('data-unit-in') || 'in');
    };

    /* Nobody says their height in inches. Feet and inches in imperial,
       centimetres in metric, and the tool works in cm underneath. */
    var fmtHeight = function (cm) {
      if (unit === 'cm') { return Math.round(cm) + ' ' + (root.getAttribute('data-unit-cm') || 'cm'); }
      var total = Math.round(cm / 2.54);
      return Math.floor(total / 12) + '\u2032 ' + (total % 12) + '\u2033';
    };

    var fill = function (tpl, usable) {
      return String(tpl || '').split('{span}').join(fmt(usable));
    };

    var paint = function () {
      var h = +range.value;
      var usable = STRAP_CM - GRIP_CM * 2;
      var needed = h * SHARE;
      var slack = usable - needed;

      val.textContent = fmtHeight(h);
      if (span) { span.textContent = fmt(usable); }
      if (need) { need.textContent = fmt(needed); }

      /* Both bars are drawn against the same maximum — the strap's own full
         length — so the two widths can be compared by eye. A bar scaled to
         its own value would look identical at every height. */
      if (haveBar) { haveBar.style.width = Math.round(usable / STRAP_CM * 100) + '%'; }
      if (needBar) { needBar.style.width = Math.round(Math.min(1, needed / STRAP_CM) * 100) + '%'; }

      var state = slack >= ROOM ? 'yes' : 'tight';
      root.setAttribute('data-reach-state', state);
      head.textContent = root.getAttribute('data-head-' + state) || '';
      out.innerHTML = fill(root.getAttribute('data-msg-' + state), usable);
    };

    range.addEventListener('input', paint);

    root.addEventListener('click', function (e) {
      var u = e.target.closest('[data-reach-unit]');
      if (!u) { return; }
      unit = u.getAttribute('data-reach-unit');
      units.forEach(function (b) {
        var on = b.getAttribute('data-reach-unit') === unit;
        b.classList.toggle('is-on', on);
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      paint();
    });

    paint();
  }
  function scan(ctx) {
    var scope = ctx && ctx.querySelectorAll ? ctx : document;
    [].forEach.call(scope.querySelectorAll('[data-mp-reach]'), init);
    if (scope !== document && scope.matches && scope.matches('[data-mp-reach]')) init(scope);
  }
  scan(document);
  document.addEventListener('shopify:section:load', function (e) { scan(e.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mp-reviews"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';
  function init(root) {
    if (root.dataset.mpReady === '1') return;
    root.dataset.mpReady = '1';
    var chips = [].slice.call(root.querySelectorAll('[data-chip]'));
    var cards = [].slice.call(root.querySelectorAll('.rv'));
    var count = root.querySelector('[data-rv-count]');
    var more = root.querySelector('[data-rv-more]');
    var empty = root.querySelector('[data-rv-empty]');
    if (!cards.length) { return; }

    var FOLD = +root.getAttribute('data-fold') || 6;
    var TPL_SOME = root.getAttribute('data-tpl-some') || 'Showing {n} of {all}';
    var TPL_ALL = root.getAttribute('data-tpl-all') || 'Showing all {all}';
    var CRIT = +root.getAttribute('data-critical-at') || 3;
    var open = false;

    cards.forEach(function (c, i) { if (i >= FOLD) { c.setAttribute('data-more', ''); } });

    var paint = function (topic) {
      /* Count what is on screen, not what matched. Those are different
         numbers while the wall is folded, and a counter that says "all 12"
         over six visible cards is the page contradicting itself. */
      var shown = 0;
      cards.forEach(function (c) {
        var match = topic === 'all' ||
          (topic === 'critical' ? +c.getAttribute('data-stars') <= CRIT : c.getAttribute('data-topic') === topic);
        /* Folding only applies while the wall is unfiltered. Once you have
           asked for one topic, hiding half the answer is just rude. */
        var folded = !open && topic === 'all' && c.hasAttribute('data-more');
        c.hidden = !match || folded;
        if (!c.hidden) { shown++; }
      });
      if (count) {
        count.textContent = (shown === cards.length ? TPL_ALL : TPL_SOME)
          .split('{n}').join(shown).split('{all}').join(cards.length);
      }
      if (empty) { empty.hidden = shown > 0; }
      if (more) { more.hidden = open || topic !== 'all' || cards.length <= FOLD; }
    };

    root.addEventListener('click', function (e) {
      var chip = e.target.closest('[data-chip]');
      if (chip) {
        chips.forEach(function (c) {
          var on = c === chip;
          c.classList.toggle('is-on', on);
          c.setAttribute('aria-pressed', on ? 'true' : 'false');
        });
        paint(chip.getAttribute('data-chip'));
        return;
      }
      if (e.target.closest('[data-rv-more]')) {
        open = true;
        var active = chips.filter(function (c) { return c.classList.contains('is-on'); })[0];
        paint(active ? active.getAttribute('data-chip') : 'all');
      }
    });

    paint('all');
  }
  function scan(ctx) {
    var scope = ctx && ctx.querySelectorAll ? ctx : document;
    [].forEach.call(scope.querySelectorAll('[data-mp-reviews]'), init);
    if (scope !== document && scope.matches && scope.matches('[data-mp-reviews]')) init(scope);
  }
  scan(document);
  document.addEventListener('shopify:section:load', function (e) { scan(e.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mp-step"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';
  function init(root) {
    if (root.dataset.mpReady === '1') return;
    root.dataset.mpReady = '1';
    var btns = [].slice.call(root.querySelectorAll('[data-step]'));
    var panels = [].slice.call(root.querySelectorAll('[data-step-panel]'));
    var prev = root.querySelector('[data-step-prev]');
    var next = root.querySelector('[data-step-next]');
    if (!btns.length) { return; }
    var LAST = root.getAttribute('data-last-label') || 'That is all of it';
    var NEXT = root.getAttribute('data-next-label') || 'Next step';
    var at = 0;

    var show = function (i) {
      at = Math.max(0, Math.min(btns.length - 1, i));
      btns.forEach(function (b, n) {
        b.classList.toggle('is-on', n === at);
        if (n === at) { b.setAttribute('aria-current', 'step'); } else { b.removeAttribute('aria-current'); }
      });
      panels.forEach(function (p, n) { p.classList.toggle('is-on', n === at); });
      if (prev) { prev.disabled = at === 0; }
      if (next) {
        /* The last step's button says what it is, rather than pretending
           there is another one. */
        next.disabled = at === btns.length - 1;
        next.textContent = at === btns.length - 1 ? LAST : NEXT;
      }
    };

    root.addEventListener('click', function (e) {
      var b = e.target.closest('[data-step]');
      if (b) { show(+b.getAttribute('data-step')); return; }
      if (e.target.closest('[data-step-next]')) { show(at + 1); return; }
      if (e.target.closest('[data-step-prev]')) { show(at - 1); }
    });

    show(0);
  }
  function scan(ctx) {
    var scope = ctx && ctx.querySelectorAll ? ctx : document;
    [].forEach.call(scope.querySelectorAll('[data-mp-steps]'), init);
    if (scope !== document && scope.matches && scope.matches('[data-mp-steps]')) init(scope);
  }
  scan(document);
  document.addEventListener('shopify:section:load', function (e) { scan(e.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mp-zone"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';
  function init(root) {
    if (root.dataset.mpReady === '1') return;
    root.dataset.mpReady = '1';
    var tabs = [].slice.call(root.querySelectorAll('[role="tab"]'));
    var panels = [].slice.call(root.querySelectorAll('[role="tabpanel"]'));
    if (!tabs.length) { return; }

    var select = function (id, focus) {
      tabs.forEach(function (t) {
        var on = t.getAttribute('data-zone') === id;
        t.setAttribute('aria-selected', on ? 'true' : 'false');
        t.tabIndex = on ? 0 : -1;
        if (on && focus) { t.focus(); }
      });
      panels.forEach(function (p) { p.hidden = p.getAttribute('data-zone-panel') !== id; });
    };

    root.addEventListener('click', function (e) {
      var t = e.target.closest('[role="tab"]');
      if (t) { select(t.getAttribute('data-zone')); }
    });

    root.addEventListener('keydown', function (e) {
      var t = e.target.closest('[role="tab"]');
      if (!t) { return; }
      var i = tabs.indexOf(t), n = null;
      if (e.key === 'ArrowRight') { n = (i + 1) % tabs.length; }
      else if (e.key === 'ArrowLeft') { n = (i - 1 + tabs.length) % tabs.length; }
      else if (e.key === 'Home') { n = 0; }
      else if (e.key === 'End') { n = tabs.length - 1; }
      if (n === null) { return; }
      e.preventDefault();
      select(tabs[n].getAttribute('data-zone'), true);
    });

    select(tabs[0].getAttribute('data-zone'));
  }
  function scan(ctx) {
    var scope = ctx && ctx.querySelectorAll ? ctx : document;
    [].forEach.call(scope.querySelectorAll('[data-mp-zones]'), init);
    if (scope !== document && scope.matches && scope.matches('[data-mp-zones]')) init(scope);
  }
  scan(document);
  document.addEventListener('shopify:section:load', function (e) { scan(e.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nv-01-buybox"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';
  function init(root) {
    if (root.dataset.nvReady === '1') return;
    root.dataset.nvReady = '1';
    var gal = root.querySelector('[data-nv-gal]');
    var wrapEl = root.closest('.nv') || document;
    var setAll = function (sel, value) {
      [].forEach.call(wrapEl.querySelectorAll(sel), function (e) { e.textContent = value; });
    };
    if (gal) {
      var slides = [].slice.call(gal.querySelectorAll('.gal__f'));
      var thumbs = [].slice.call(gal.querySelectorAll('.gal__t'));
      var count = gal.querySelector('.gal__ct b');
      var total = gal.querySelector('[data-gal-total]');
      var at = 0;
      if (total) { total.textContent = String(slides.length); }
      var show = function (i) {
        if (!slides.length) { return; }
        at = (i + slides.length) % slides.length;
        slides.forEach(function (s, n) {
          s.classList.toggle('is-on', n === at);
          if (n === at) { s.removeAttribute('aria-hidden'); } else { s.setAttribute('aria-hidden', 'true'); }
        });
        thumbs.forEach(function (t, n) { t.classList.toggle('is-on', n === at); t.setAttribute('aria-selected', n === at ? 'true' : 'false'); });
        if (count) { count.textContent = String(at + 1); }
      };
      thumbs.forEach(function (t) { t.addEventListener('click', function () { show(+t.getAttribute('data-i')); }); });
      var prev = gal.querySelector('.gal__nav--p'), next = gal.querySelector('.gal__nav--n');
      if (prev) { prev.addEventListener('click', function () { show(at - 1); }); }
      if (next) { next.addEventListener('click', function () { show(at + 1); }); }
      gal.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight') { show(at + 1); e.preventDefault(); }
        if (e.key === 'ArrowLeft') { show(at - 1); e.preventDefault(); }
      });
      var x0 = null, y0 = null;
      gal.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; y0 = e.touches[0].clientY; }, { passive: true });
      gal.addEventListener('touchend', function (e) {
        if (x0 === null) { return; }
        var dx = e.changedTouches[0].clientX - x0, dy = e.changedTouches[0].clientY - y0;
        if (Math.abs(dx) > 44 && Math.abs(dx) > Math.abs(dy)) { show(at + (dx < 0 ? 1 : -1)); }
        x0 = null; y0 = null;
      }, { passive: true });
    }

    /* The variant: every string was produced by Liquid's money filter and
       parked on the radio. Nothing here parses or multiplies a price. */
    var variants = [].slice.call(root.querySelectorAll('input[name=id][type=radio]'));
    var paint = function () {
      var on = variants.filter(function (v) { return v.checked; })[0];
      if (!on) { return; }
      setAll('[data-price-now]', on.getAttribute('data-price'));
      setAll('[data-echo]', on.getAttribute('data-title'));
      var hasCmp = on.getAttribute('data-has-cmp') === '1';
      [].forEach.call(wrapEl.querySelectorAll('[data-price-was]'), function (e) {
        e.hidden = !hasCmp;
        if (hasCmp) { e.textContent = on.getAttribute('data-cmp'); }
      });
    };
    variants.forEach(function (v) { v.addEventListener('change', paint); });

    var q = root.querySelector('[data-qty]');
    if (q) {
      var clamp = function (n) { return Math.max(1, Math.min(99, isNaN(n) ? 1 : n)); };
      var step = function (d) { q.value = clamp(parseInt(q.value, 10) + d); };
      var mi = root.querySelector('[data-minus]'), pl = root.querySelector('[data-plus]');
      if (mi) { mi.addEventListener('click', function () { step(-1); }); }
      if (pl) { pl.addEventListener('click', function () { step(1); }); }
      q.addEventListener('change', function () { q.value = clamp(parseInt(q.value, 10)); });
    }

    /* A scroll listener rather than an IntersectionObserver: an observer
       misses an instant jump past the button, and the bar never appears. */
    var stk = wrapEl.querySelector('[data-nv-sticky]');
    var anchor = root.querySelector('.bb__buy');
    if (stk && anchor) {
      var queued = false;
      var sync = function () { queued = false; stk.hidden = anchor.getBoundingClientRect().bottom > 0; };
      var onMove = function () {
        if (queued) { return; }
        queued = true;
        if (window.requestAnimationFrame) { window.requestAnimationFrame(sync); } else { setTimeout(sync, 16); }
      };
      window.addEventListener('scroll', onMove, { passive: true });
      window.addEventListener('resize', onMove);
      sync();
    }
  }
  function scan(ctx) {
    var scope = ctx && ctx.querySelectorAll ? ctx : document;
    [].forEach.call(scope.querySelectorAll('[data-nv-buy]'), init);
    if (scope !== document && scope.matches && scope.matches('[data-nv-buy]')) init(scope);
  }
  scan(document);
  document.addEventListener('shopify:section:load', function (e) { scan(e.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nv-11-reviews"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';
  function init(root) {
    if (root.dataset.nvReady === '1') return;
    root.dataset.nvReady = '1';
    var grid = root.querySelector('[data-rv-grid]');
    if (grid) {
      var cards = [].slice.call(grid.querySelectorAll('.rv__c'));
      var chips = [].slice.call(root.querySelectorAll('.rv__ch'));
      var more = root.querySelector('[data-rv-more]');
      var none = root.querySelector('[data-rv-none]');
      var step = 6;
      var topic = '';
      var shown = step;

      var paint = function () {
        var matched = cards.filter(function (c) {
          return topic === '' || c.getAttribute('data-topic') === topic;
        });
        cards.forEach(function (c) { c.hidden = true; });
        matched.slice(0, shown).forEach(function (c) { c.hidden = false; });
        if (none) { none.hidden = matched.length > 0; }
        if (more) { more.hidden = matched.length <= shown; }
      };

      chips.forEach(function (ch) {
        ch.addEventListener('click', function () {
          topic = ch.getAttribute('data-topic');
          shown = step;
          chips.forEach(function (o) {
            var on = o === ch;
            o.classList.toggle('is-on', on);
            o.setAttribute('aria-pressed', on ? 'true' : 'false');
          });
          paint();
        });
      });
      if (more) { more.addEventListener('click', function () { shown += step; paint(); }); }
      paint();
    }
  }
  function scan(ctx) {
    var scope = ctx && ctx.querySelectorAll ? ctx : document;
    [].forEach.call(scope.querySelectorAll('[data-nv-rv]'), init);
    if (scope !== document && scope.matches && scope.matches('[data-nv-rv]')) init(scope);
  }
  scan(document);
  document.addEventListener('shopify:section:load', function (e) { scan(e.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ow-buy-box"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';
  function init(root) {
    if (root.dataset.owReady === '1') return;
    root.dataset.owReady = '1';
    var gal = root.querySelector('[data-ow-gal]');
    var wrapEl = root.closest('.ow') || document;
    var setAll = function (sel, value) {
      [].forEach.call(wrapEl.querySelectorAll(sel), function (e) { e.textContent = value; });
    };

    /* ── Gallery ─────────────────────────────────────────────────────── */
    if (gal) {
      var slides = [].slice.call(gal.querySelectorAll('.gal__f'));
      var thumbs = [].slice.call(gal.querySelectorAll('.gal__t'));
      var count = gal.querySelector('.gal__ct b');
      var total = gal.querySelector('[data-gal-total]');
      var at = 0;
      if (total) { total.textContent = String(slides.length); }

      var show = function (i) {
        if (!slides.length) { return; }
        at = (i + slides.length) % slides.length;
        slides.forEach(function (s, n) {
          s.classList.toggle('is-on', n === at);
          if (n === at) { s.removeAttribute('aria-hidden'); } else { s.setAttribute('aria-hidden', 'true'); }
        });
        thumbs.forEach(function (t, n) {
          t.classList.toggle('is-on', n === at);
          t.setAttribute('aria-selected', n === at ? 'true' : 'false');
        });
        if (count) { count.textContent = String(at + 1); }
      };

      thumbs.forEach(function (t) {
        t.addEventListener('click', function () { show(+t.getAttribute('data-i')); });
      });
      var prev = gal.querySelector('.gal__nav--p');
      var next = gal.querySelector('.gal__nav--n');
      if (prev) { prev.addEventListener('click', function () { show(at - 1); }); }
      if (next) { next.addEventListener('click', function () { show(at + 1); }); }

      /* Arrow keys, but only while the gallery has focus — hijacking them
         for the whole document is how a page becomes unusable. */
      gal.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight') { show(at + 1); e.preventDefault(); }
        if (e.key === 'ArrowLeft') { show(at - 1); e.preventDefault(); }
      });

      /* Swipe, because most of this traffic is a thumb on a phone. A drag
         that is more vertical than horizontal is the page scrolling and is
         left alone. */
      var x0 = null, y0 = null;
      gal.addEventListener('touchstart', function (e) {
        x0 = e.touches[0].clientX; y0 = e.touches[0].clientY;
      }, { passive: true });
      gal.addEventListener('touchend', function (e) {
        if (x0 === null) { return; }
        var dx = e.changedTouches[0].clientX - x0, dy = e.changedTouches[0].clientY - y0;
        if (Math.abs(dx) > 44 && Math.abs(dx) > Math.abs(dy)) { show(at + (dx < 0 ? 1 : -1)); }
        x0 = null; y0 = null;
      }, { passive: true });
    }

    /* ── Variant and quantity ────────────────────────────────────────────
       Two radio groups, and every combination of the two was worked out in
       Liquid. This looks up the attribute for the selected variant; it does
       not multiply. */
    var versions = [].slice.call(root.querySelectorAll('input[name=id]'));
    /* Both kinds of pack row. A quantity row posts name="quantity"; a row
       bound to a real bundle variant posts name="id" and is also in
       the versions list. Selecting on .pk catches both kinds without
       caring which.
       NB: no backticks in this comment — the whole script is one JS
       template literal and a backtick here ends it early, which is exactly
       what it did. */
    var rows = [].slice.call(root.querySelectorAll('.pk input[type=radio]'));

    var currentVariant = function () {
      var on = versions.filter(function (v) { return v.checked; })[0];
      if (on) { return on.getAttribute('data-vid') || on.value; }
      return versions.length ? (versions[0].getAttribute('data-vid') || versions[0].value) : '';
    };

    var paint = function () {
      var vid = currentVariant();
      if (!vid) { return; }
      /* A quantity row keys its strings by variant, because its total
         depends on which variant is selected. A variant row has one price
         and keys them plainly. Falling back from one to the other is what
         lets a section carry both kinds at once. */
      var get = function (el, key) {
        return el.getAttribute('data-' + key + '-' + vid) || el.getAttribute('data-' + key) || '';
      };

      /* every row reprices itself for the variant now selected */
      rows.forEach(function (r) {
        var row = r.closest('.pk');
        if (!row) { return; }
        row.classList.toggle('is-on', r.checked);
        var totalEl = row.querySelector('[data-pack-total]');
        var eachEl = row.querySelector('[data-pack-each]');
        if (totalEl) { totalEl.textContent = get(r, 'total'); }
        if (eachEl) {
          var each = get(r, 'each');
          if (each) { eachEl.textContent = each + ' ' + (eachEl.getAttribute('data-word') || ''); }
        }
      });

      var sel = rows.filter(function (r) { return r.checked; })[0] || rows[0];
      if (sel) {
        setAll('[data-price-now]', get(sel, 'total'));
        setAll('[data-echo-pack]', sel.getAttribute('data-label') || '');
        var hasCmp = +get(sel, 'has-cmp') > 0;
        [].forEach.call(wrapEl.querySelectorAll('[data-price-was]'), function (e) {
          e.hidden = !hasCmp;
          e.textContent = get(sel, 'cmp');
        });
        var eachStr = get(sel, 'each');
        [].forEach.call(wrapEl.querySelectorAll('[data-price-each]'), function (e) {
          if (eachStr) { e.textContent = eachStr + ' ' + (e.getAttribute('data-word') || ''); }
        });
      }

      var onV = versions.filter(function (v) { return v.checked; })[0];
      if (onV) { setAll('[data-echo-version]', onV.getAttribute('data-title') || ''); }
      versions.forEach(function (v) {
        var l = v.closest('.vopt');
        if (l) { l.classList.toggle('is-on', v.checked); }
      });
    };

    versions.concat(rows).forEach(function (i) { i.addEventListener('change', paint); });
    paint();

    /* ── The quantity stepper ────────────────────────────────────────────
       Present only when there are no pack rows to be the quantity field.
       It clamps rather than trusting the input, because a number input
       accepts "-3" and an empty string from a keyboard. */
    var qty = root.querySelector('[data-qty]');
    if (qty) {
      var clamp = function () {
        var n = parseInt(qty.value, 10);
        if (!(n > 0)) { n = 1; }
        if (n > 99) { n = 99; }
        if (String(n) !== qty.value) { qty.value = n; }
      };
      qty.addEventListener('input', clamp);
      qty.addEventListener('change', clamp);
      var minus = root.querySelector('[data-minus]');
      var plus = root.querySelector('[data-plus]');
      if (minus) { minus.addEventListener('click', function () { qty.value = Math.max(1, (parseInt(qty.value, 10) || 1) - 1); clamp(); }); }
      if (plus) { plus.addEventListener('click', function () { qty.value = Math.min(99, (parseInt(qty.value, 10) || 1) + 1); clamp(); }); }
    }

    /* ── The picker ──────────────────────────────────────────────────────
       The input IS the line item property, so there is nothing to copy into
       a hidden field. This only keeps the card layout's selected state in
       step; the dropdown needs no script at all. */
    var picks = [].slice.call(root.querySelectorAll('input[data-ow-pick]'));
    if (picks.length) {
      var paintPick = function () {
        picks.forEach(function (p) {
          var l = p.closest('.occ__c');
          if (l) { l.classList.toggle('is-on', p.checked); }
        });
      };
      picks.forEach(function (p) { p.addEventListener('change', paintPick); });
      paintPick();
    }

    /* ── Sticky bar ──────────────────────────────────────────────────────
       Measured directly rather than observed. An IntersectionObserver only
       calls back when the ratio CROSSES a threshold, and a buy box tall
       enough to push the button below the fold starts at ratio 0 and is
       still at ratio 0 after the page scrolls past it — nothing crossed,
       nothing fired, and the bar never appeared. Reading the rect answers
       the question directly at every viewport height. rAF-throttled, so it
       costs at most one rect read per painted frame. */
    var bar = wrapEl.querySelector('[data-ow-sticky]');
    var anchor = root.querySelector('.bb__atc');
    if (bar && anchor) {
      var pending = 0;
      var measure = function () {
        pending = 0;
        bar.hidden = anchor.getBoundingClientRect().bottom > 0;
      };
      var schedule = function () {
        if (pending) { return; }
        pending = window.requestAnimationFrame ? requestAnimationFrame(measure) : setTimeout(measure, 60);
      };
      window.addEventListener('scroll', schedule, { passive: true });
      window.addEventListener('resize', schedule, { passive: true });
      measure();
    }
  }
  function scan(ctx) {
    var scope = ctx && ctx.querySelectorAll ? ctx : document;
    [].forEach.call(scope.querySelectorAll('[data-ow-buy]'), init);
    if (scope !== document && scope.matches && scope.matches('[data-ow-buy]')) init(scope);
  }
  scan(document);
  document.addEventListener('shopify:section:load', function (e) { scan(e.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ow-reviews"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';
  function init(root) {
    if (root.dataset.owReady === '1') return;
    root.dataset.owReady = '1';
    var list = root.querySelector('[data-list]');
    if (list) {
      var cards = [].slice.call(list.querySelectorAll('.rv'));
      var chips = [].slice.call(root.querySelectorAll('[data-f]'));
      var empty = root.querySelector('[data-empty]');
      chips.forEach(function (c) {
        c.addEventListener('click', function () {
          var k = c.getAttribute('data-f');
          chips.forEach(function (o) {
            var on = o === c;
            o.classList.toggle('is-on', on);
            o.setAttribute('aria-pressed', on ? 'true' : 'false');
          });
          var shown = 0;
          cards.forEach(function (card) {
            var ok = k === 'all' || card.getAttribute('data-t') === k;
            card.hidden = !ok;
            if (ok) { shown++; }
          });
          if (empty) { empty.hidden = shown > 0; }
        });
      });
    }
  }
  function scan(ctx) {
    var scope = ctx && ctx.querySelectorAll ? ctx : document;
    [].forEach.call(scope.querySelectorAll('[data-ow-rev]'), init);
    if (scope !== document && scope.matches && scope.matches('[data-ow-rev]')) init(scope);
  }
  scan(document);
  document.addEventListener('shopify:section:load', function (e) { scan(e.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ps-01-buybox"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';
  function init(root) {
    if (root.dataset.psReady === '1') return;
    root.dataset.psReady = '1';
    var gal = root.querySelector('[data-ps-gal]');
    var wrapEl = root.closest('.ps') || document;
    var setAll = function (sel, value) {
      [].forEach.call(wrapEl.querySelectorAll(sel), function (e) { e.textContent = value; });
    };
    if (gal) {
      var slides = [].slice.call(gal.querySelectorAll('.gal__f'));
      var thumbs = [].slice.call(gal.querySelectorAll('.gal__t'));
      var count = gal.querySelector('.gal__ct b');
      var total = gal.querySelector('[data-gal-total]');
      var at = 0;
      if (total) { total.textContent = String(slides.length); }
      var show = function (i) {
        if (!slides.length) { return; }
        at = (i + slides.length) % slides.length;
        slides.forEach(function (s, n) {
          s.classList.toggle('is-on', n === at);
          if (n === at) { s.removeAttribute('aria-hidden'); } else { s.setAttribute('aria-hidden', 'true'); }
        });
        thumbs.forEach(function (t, n) { t.classList.toggle('is-on', n === at); t.setAttribute('aria-selected', n === at ? 'true' : 'false'); });
        if (count) { count.textContent = String(at + 1); }
      };
      thumbs.forEach(function (t) { t.addEventListener('click', function () { show(+t.getAttribute('data-i')); }); });
      var prev = gal.querySelector('.gal__nav--p'), next = gal.querySelector('.gal__nav--n');
      if (prev) { prev.addEventListener('click', function () { show(at - 1); }); }
      if (next) { next.addEventListener('click', function () { show(at + 1); }); }
      gal.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight') { show(at + 1); e.preventDefault(); }
        if (e.key === 'ArrowLeft') { show(at - 1); e.preventDefault(); }
      });
      var x0 = null, y0 = null;
      gal.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; y0 = e.touches[0].clientY; }, { passive: true });
      gal.addEventListener('touchend', function (e) {
        if (x0 === null) { return; }
        var dx = e.changedTouches[0].clientX - x0, dy = e.changedTouches[0].clientY - y0;
        if (Math.abs(dx) > 44 && Math.abs(dx) > Math.abs(dy)) { show(at + (dx < 0 ? 1 : -1)); }
        x0 = null; y0 = null;
      }, { passive: true });
    }

    /* The variant: every string was produced by Liquid's money filter and
       parked on the radio. Nothing here parses or multiplies a price. */
    var variants = [].slice.call(root.querySelectorAll('input[name=id][type=radio]'));
    var paint = function () {
      var on = variants.filter(function (v) { return v.checked; })[0];
      if (!on) { return; }
      setAll('[data-price-now]', on.getAttribute('data-price'));
      setAll('[data-echo]', on.getAttribute('data-title'));
      var hasCmp = on.getAttribute('data-has-cmp') === '1';
      [].forEach.call(wrapEl.querySelectorAll('[data-price-was]'), function (e) {
        e.hidden = !hasCmp;
        if (hasCmp) { e.textContent = on.getAttribute('data-cmp'); }
      });
    };
    variants.forEach(function (v) { v.addEventListener('change', paint); });

    var q = root.querySelector('[data-qty]');
    if (q) {
      var clamp = function (n) { return Math.max(1, Math.min(99, isNaN(n) ? 1 : n)); };
      var step = function (d) { q.value = clamp(parseInt(q.value, 10) + d); };
      var mi = root.querySelector('[data-minus]'), pl = root.querySelector('[data-plus]');
      if (mi) { mi.addEventListener('click', function () { step(-1); }); }
      if (pl) { pl.addEventListener('click', function () { step(1); }); }
      q.addEventListener('change', function () { q.value = clamp(parseInt(q.value, 10)); });
    }

    /* A scroll listener rather than an IntersectionObserver: an observer
       misses an instant jump past the button, and the bar never appears. */
    var stk = wrapEl.querySelector('[data-ps-sticky]');
    var anchor = root.querySelector('.bb__buy');
    if (stk && anchor) {
      var queued = false;
      var sync = function () { queued = false; stk.hidden = anchor.getBoundingClientRect().bottom > 0; };
      var onMove = function () {
        if (queued) { return; }
        queued = true;
        if (window.requestAnimationFrame) { window.requestAnimationFrame(sync); } else { setTimeout(sync, 16); }
      };
      window.addEventListener('scroll', onMove, { passive: true });
      window.addEventListener('resize', onMove);
      sync();
    }
  }
  function scan(ctx) {
    var scope = ctx && ctx.querySelectorAll ? ctx : document;
    [].forEach.call(scope.querySelectorAll('[data-ps-buy]'), init);
    if (scope !== document && scope.matches && scope.matches('[data-ps-buy]')) init(scope);
  }
  scan(document);
  document.addEventListener('shopify:section:load', function (e) { scan(e.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ps-11-reviews"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';
  function init(root) {
    if (root.dataset.psReady === '1') return;
    root.dataset.psReady = '1';
    var grid = root.querySelector('[data-rv-grid]');
    if (grid) {
      var cards = [].slice.call(grid.querySelectorAll('.rv__c'));
      var chips = [].slice.call(root.querySelectorAll('.rv__ch'));
      var more = root.querySelector('[data-rv-more]');
      var none = root.querySelector('[data-rv-none]');
      var step = 6;
      var topic = '';
      var shown = step;

      var paint = function () {
        var matched = cards.filter(function (c) {
          return topic === '' || c.getAttribute('data-topic') === topic;
        });
        cards.forEach(function (c) { c.hidden = true; });
        matched.slice(0, shown).forEach(function (c) { c.hidden = false; });
        if (none) { none.hidden = matched.length > 0; }
        if (more) { more.hidden = matched.length <= shown; }
      };

      chips.forEach(function (ch) {
        ch.addEventListener('click', function () {
          topic = ch.getAttribute('data-topic');
          shown = step;
          chips.forEach(function (o) {
            var on = o === ch;
            o.classList.toggle('is-on', on);
            o.setAttribute('aria-pressed', on ? 'true' : 'false');
          });
          paint();
        });
      });
      if (more) { more.addEventListener('click', function () { shown += step; paint(); }); }
      paint();
    }
  }
  function scan(ctx) {
    var scope = ctx && ctx.querySelectorAll ? ctx : document;
    [].forEach.call(scope.querySelectorAll('[data-ps-rv]'), init);
    if (scope !== document && scope.matches && scope.matches('[data-ps-rv]')) init(scope);
  }
  scan(document);
  document.addEventListener('shopify:section:load', function (e) { scan(e.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ql-buybox"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';
  function init(root) {
    if (root.dataset.qlReady === '1') return;
    root.dataset.qlReady = '1';
    var gal = root.querySelector('[data-ql-gal]');
    var wrapEl = root.closest('.ql') || document;
    var setAll = function (sel, value) {
      [].forEach.call(wrapEl.querySelectorAll(sel), function (e) { e.textContent = value; });
    };

    /* ── Gallery ─────────────────────────────────────────────────────── */
    if (gal) {
      var slides = [].slice.call(gal.querySelectorAll('.gal__f'));
      var thumbs = [].slice.call(gal.querySelectorAll('.gal__t'));
      var count = gal.querySelector('.gal__ct b');
      var total = gal.querySelector('[data-gal-total]');
      var at = 0;
      if (total) { total.textContent = String(slides.length); }

      var show = function (i) {
        if (!slides.length) { return; }
        at = (i + slides.length) % slides.length;
        slides.forEach(function (s, n) {
          s.classList.toggle('is-on', n === at);
          if (n === at) { s.removeAttribute('aria-hidden'); } else { s.setAttribute('aria-hidden', 'true'); }
        });
        thumbs.forEach(function (t, n) {
          t.classList.toggle('is-on', n === at);
          t.setAttribute('aria-selected', n === at ? 'true' : 'false');
        });
        if (count) { count.textContent = String(at + 1); }
      };

      thumbs.forEach(function (t) {
        t.addEventListener('click', function () { show(+t.getAttribute('data-i')); });
      });
      var prev = gal.querySelector('.gal__nav--p');
      var next = gal.querySelector('.gal__nav--n');
      if (prev) { prev.addEventListener('click', function () { show(at - 1); }); }
      if (next) { next.addEventListener('click', function () { show(at + 1); }); }

      /* Arrow keys, but only while the gallery has focus — hijacking them
         for the whole document is how a page becomes unusable. */
      gal.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight') { show(at + 1); e.preventDefault(); }
        if (e.key === 'ArrowLeft') { show(at - 1); e.preventDefault(); }
      });

      /* Swipe, because most of this traffic is a thumb on a phone. A drag
         more vertical than horizontal is the page scrolling, and is left
         alone. */
      var x0 = null, y0 = null;
      gal.addEventListener('touchstart', function (e) {
        x0 = e.touches[0].clientX; y0 = e.touches[0].clientY;
      }, { passive: true });
      gal.addEventListener('touchend', function (e) {
        if (x0 === null) { return; }
        var dx = e.changedTouches[0].clientX - x0, dy = e.changedTouches[0].clientY - y0;
        if (Math.abs(dx) > 44 && Math.abs(dx) > Math.abs(dy)) { show(at + (dx < 0 ? 1 : -1)); }
        x0 = null; y0 = null;
      }, { passive: true });
    }

    /* ── The finish, which is the variant ────────────────────────────────
       Every string was produced by Liquid's money filter. This moves them;
       it does not compute them. */
    var variants = [].slice.call(root.querySelectorAll('input[name=id]'));
    var paint = function () {
      var on = variants.filter(function (v) { return v.checked; })[0];
      if (!on) { return; }
      setAll('[data-price-now]', on.getAttribute('data-price') || '');
      setAll('[data-echo]', on.getAttribute('data-title') || '');
      setAll('[data-pname]', on.getAttribute('data-title') || '');
      var hasCmp = on.getAttribute('data-has-cmp') === '1';
      [].forEach.call(wrapEl.querySelectorAll('[data-price-was]'), function (e) {
        e.hidden = !hasCmp;
        e.textContent = on.getAttribute('data-cmp') || '';
      });
    };
    variants.forEach(function (v) { v.addEventListener('change', paint); });
    paint();

    /* ── The quantity stepper ────────────────────────────────────────────
       And the one rule that keeps the button honest: it shows the variant
       price while the quantity is one, and stops showing a price the moment
       it is not. A line total would mean multiplying a money string in the
       browser, which is correct until the first shop that sells in yen. */
    var qty = root.querySelector('[data-qty]');
    var atcPrice = root.querySelector('[data-atc-price]');
    if (qty) {
      var clamp = function () {
        var n = parseInt(qty.value, 10);
        if (!(n > 0)) { n = 1; }
        if (n > 99) { n = 99; }
        if (String(n) !== qty.value) { qty.value = n; }
        if (atcPrice) { atcPrice.hidden = n !== 1; }
      };
      qty.addEventListener('input', clamp);
      qty.addEventListener('change', clamp);
      var minus = root.querySelector('[data-minus]');
      var plus = root.querySelector('[data-plus]');
      if (minus) { minus.addEventListener('click', function () { qty.value = Math.max(1, (parseInt(qty.value, 10) || 1) - 1); clamp(); }); }
      if (plus) { plus.addEventListener('click', function () { qty.value = Math.min(99, (parseInt(qty.value, 10) || 1) + 1); clamp(); }); }
      clamp();
    }

    /* ── Sticky bar ──────────────────────────────────────────────────────
       Measured directly rather than observed. An IntersectionObserver only
       calls back when the ratio CROSSES a threshold, and a buy box tall
       enough to push the button below the fold starts at ratio 0 and is
       still 0 after the page scrolls past it — nothing crossed, nothing
       fires, the bar never appears. Reading the rect answers the question
       at every viewport height. rAF-throttled. */
    var bar = wrapEl.querySelector('[data-ql-sticky]');
    var anchor = root.querySelector('.bb__atc');
    if (bar && anchor) {
      var pending = 0;
      var measure = function () {
        pending = 0;
        bar.hidden = anchor.getBoundingClientRect().bottom > 0;
      };
      var schedule = function () {
        if (pending) { return; }
        pending = window.requestAnimationFrame ? requestAnimationFrame(measure) : setTimeout(measure, 60);
      };
      window.addEventListener('scroll', schedule, { passive: true });
      window.addEventListener('resize', schedule, { passive: true });
      measure();
    }
  }
  function scan(ctx) {
    var scope = ctx && ctx.querySelectorAll ? ctx : document;
    [].forEach.call(scope.querySelectorAll('[data-ql-buy]'), init);
    if (scope !== document && scope.matches && scope.matches('[data-ql-buy]')) init(scope);
  }
  scan(document);
  document.addEventListener('shopify:section:load', function (e) { scan(e.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ql-review"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';
  function init(root) {
    if (root.dataset.qlReady === '1') return;
    root.dataset.qlReady = '1';
    var list = root.querySelector('[data-list]');
    if (list) {
      var cards = [].slice.call(list.querySelectorAll('.rv'));
      var chips = [].slice.call(root.querySelectorAll('[data-f]'));
      var empty = root.querySelector('[data-empty]');
      chips.forEach(function (c) {
        c.addEventListener('click', function () {
          var k = c.getAttribute('data-f');
          chips.forEach(function (o) {
            var on = o === c;
            o.classList.toggle('is-on', on);
            o.setAttribute('aria-pressed', on ? 'true' : 'false');
          });
          var shown = 0;
          cards.forEach(function (card) {
            var ok = k === 'all' || card.getAttribute('data-t') === k;
            card.hidden = !ok;
            if (ok) { shown++; }
          });
          if (empty) { empty.hidden = shown > 0; }
        });
      });
    }
  }
  function scan(ctx) {
    var scope = ctx && ctx.querySelectorAll ? ctx : document;
    [].forEach.call(scope.querySelectorAll('[data-ql-rev]'), init);
    if (scope !== document && scope.matches && scope.matches('[data-ql-rev]')) init(scope);
  }
  scan(document);
  document.addEventListener('shopify:section:load', function (e) { scan(e.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sh-build"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';
  function init(root) {
    if (root.dataset.shReady === '1') return;
    root.dataset.shReady = '1';
    var im = root.querySelector('[data-hot-im]');
    var panels = [].slice.call(root.querySelectorAll('[data-spot-panel]'));
    if (!im) { return; }
    var dots = [].slice.call(im.querySelectorAll('.hotdot'));
    if (!dots.length) { return; }

    var show = function (i) {
      dots.forEach(function (d) {
        var on = d.getAttribute('data-spot') === String(i);
        d.classList.toggle('is-on', on);
        if (on) { d.setAttribute('aria-current', 'true'); } else { d.removeAttribute('aria-current'); }
      });
      panels.forEach(function (p) {
        p.classList.toggle('is-on', p.getAttribute('data-spot-panel') === String(i));
      });
    };

    /* Delegated, so a fifth marker added in the editor needs no rebind. */
    im.addEventListener('click', function (e) {
      var d = e.target.closest('.hotdot');
      if (d) { show(d.getAttribute('data-spot')); }
    });

    /* Hovering counts as asking, on a device that can hover. */
    if (window.matchMedia('(hover:hover)').matches) {
      dots.forEach(function (d) {
        d.addEventListener('mouseenter', function () { show(d.getAttribute('data-spot')); });
      });
    }

    show(dots[0].getAttribute('data-spot'));
  }
  function scan(ctx) {
    var scope = ctx && ctx.querySelectorAll ? ctx : document;
    [].forEach.call(scope.querySelectorAll('[data-sh-hot]'), init);
    if (scope !== document && scope.matches && scope.matches('[data-sh-hot]')) init(scope);
  }
  scan(document);
  document.addEventListener('shopify:section:load', function (e) { scan(e.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sh-buybox"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';
  function init(root) {
    if (root.dataset.shReady === '1') return;
    root.dataset.shReady = '1';
    var gal = root.querySelector('[data-sh-gal]');
    var thumbs = [].slice.call(root.querySelectorAll('.thumb'));
    var wrapEl = root.closest('.sh') || document;
    /* ── Ouvrir le tiroir panier au lieu de naviguer ────────────────────
       Actif seulement si "Open the cart drawer" est choisi. Ajoute
       l'article via /cart/add.js, puis essaie plusieurs hooks courants
       des thèmes Shopify pour ouvrir LEUR tiroir. Si aucun ne correspond,
       repli sur la page /cart. En cas d'échec de la requête, le formulaire
       se soumet normalement (comportement natif). */
    
       if (root.dataset.atcAfter === 'drawer') {
      var shForm = root.querySelector('form.shform');
      if (shForm) {
        var shBypass = false;

        var shOpenDrawer = function (data) {
          document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: data }));
          document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true, detail: data }));
          document.dispatchEvent(new CustomEvent('cart:build', { bubbles: true, detail: data }));
          document.documentElement.dispatchEvent(new CustomEvent('cart:added', { bubbles: true, detail: data }));
          var triggers = [
            '#cart-icon-bubble', '#CartDrawer-trigger', '[data-cart-drawer-toggle]',
            '[data-drawer-toggle="cart"]', '.js-drawer-open-cart', '[data-cart-icon]',
            '.header__icon--cart', 'a[href$="/cart"][data-action]'
          ];
          for (var i = 0; i < triggers.length; i++) {
            var el = document.querySelector(triggers[i]);
            if (el) { el.click(); return true; }
          }
          return false;
        };

        /* Le cookie panier est déjà à jour juste après /cart/add.js. On va
           chercher une copie fraîche de la page et on ne touche qu'à
           l'INTÉRIEUR des éléments liés au panier (innerHTML) — jamais au
           nœud lui-même (outerHTML) — pour ne pas détruire le listener de
           clic posé dessus au chargement de la page. */
        var shRefreshCart = function () {
          return fetch(window.location.href, { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
            .then(function (r) { return r.text(); })
            .then(function (html) {
              var doc = new DOMParser().parseFromString(html, 'text/html');
              [].forEach.call(doc.querySelectorAll('[id]'), function (n) {
                if (!/cart/i.test(n.id)) { return; }
                var mine = document.getElementById(n.id);
                if (mine) { mine.innerHTML = n.innerHTML; }
              });
            })
            .catch(function () {});
        };

        shForm.addEventListener('submit', function (e) {
          if (shBypass) { return; }
          e.preventDefault();
          var btn = shForm.querySelector('button[name="add"]');
          if (btn) { btn.disabled = true; }
          var base = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
          fetch(base + 'cart/add.js', {
            method: 'POST',
            headers: { Accept: 'application/json' },
            body: new FormData(shForm)
          })
            .then(function (r) { return r.json(); })
            .then(function (data) {
              if (data && data.status) { throw new Error(data.description || 'add failed'); }
              var opened = shOpenDrawer(data);   // clic d'abord, sur le nœud d'origine intact
              return shRefreshCart().then(function () {
                if (!opened) { window.location.href = base + 'cart'; }
              });
            })
            .catch(function () {
              shBypass = true;
              shForm.submit();
            })
            .finally(function () {
              if (btn) { btn.disabled = false; }
            });
        });
      }
    }

    /* ── Gallery ─────────────────────────────────────────────────────── */
    if (gal) {
      var slides = [].slice.call(gal.querySelectorAll('.gslide'));
      var count = gal.querySelector('.gcount b');
      var at = 0;

      var show = function (i) {
        at = (i + slides.length) % slides.length;
        slides.forEach(function (s, n) { s.classList.toggle('is-on', n === at); });
        thumbs.forEach(function (t, n) {
          t.classList.toggle('is-on', n === at);
          if (n === at) { t.setAttribute('aria-current', 'true'); } else { t.removeAttribute('aria-current'); }
        });
        if (count) { count.textContent = String(at + 1); }
      };

      thumbs.forEach(function (t) {
        t.addEventListener('click', function () { show(+t.dataset.i); });
      });
      var prev = gal.querySelector('.gnav--prev');
      var next = gal.querySelector('.gnav--next');
      if (prev) { prev.addEventListener('click', function () { show(at - 1); }); }
      if (next) { next.addEventListener('click', function () { show(at + 1); }); }

      /* Arrow keys, but only while the gallery has focus — hijacking them
         for the whole document is how a page becomes unusable. */
      var galWrap = root.querySelector('.gal');
      if (galWrap) {
        galWrap.addEventListener('keydown', function (e) {
          if (e.key === 'ArrowRight') { show(at + 1); e.preventDefault(); }
          if (e.key === 'ArrowLeft') { show(at - 1); e.preventDefault(); }
        });
      }

      /* Swipe, because most of this traffic is a thumb on a phone. */
      var x0 = null;
      gal.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
      gal.addEventListener('touchend', function (e) {
        if (x0 === null) { return; }
        var dx = e.changedTouches[0].clientX - x0;
        if (Math.abs(dx) > 44) { show(at + (dx < 0 ? 1 : -1)); }
        x0 = null;
      }, { passive: true });
    }

    /* ── Version and quantity ────────────────────────────────────────────
       Two radio groups, and every combination of the two was worked out in
       Liquid. This looks up the attribute for the selected variant; it does
       not multiply. */
    var versions = [].slice.call(root.querySelectorAll('input[name=id]'));
    var rows = [].slice.call(root.querySelectorAll('input[name=quantity]'));
    var setAll = function (sel, value) {
      [].forEach.call(wrapEl.querySelectorAll(sel), function (e) { e.textContent = value; });
    };

    var currentVariant = function () {
      var on = versions.filter(function (v) { return v.checked; })[0];
      if (on) { return on.dataset.vid || on.value; }
      return versions.length ? (versions[0].dataset.vid || versions[0].value) : '';
    };

    var paint = function () {
      var vid = currentVariant();
      var sel = rows.filter(function (r) { return r.checked; })[0] || rows[0];
      if (!sel || !vid) { return; }

      var get = function (el, key) { return el.getAttribute('data-' + key + '-' + vid) || ''; };

      /* every row reprices itself for the version now selected */
      rows.forEach(function (r) {
        var row = r.closest('.pack');
        if (!row) { return; }
        row.classList.toggle('is-on', r.checked);
        var totalEl = row.querySelector('[data-pack-total]');
        var eachEl = row.querySelector('[data-pack-each]');
        if (totalEl) { totalEl.textContent = get(r, 'total'); }
        if (eachEl && eachEl.dataset.one !== '1') {
          var each = get(r, 'each');
          if (each && +r.value > 1) { eachEl.textContent = each + ' ' + (eachEl.dataset.word || ''); }
        }
      });

      setAll('[data-price-now]', get(sel, 'total'));
      setAll('[data-echo-pack]', sel.dataset.label || '');

      var onV = versions.filter(function (v) { return v.checked; })[0];
      if (onV) { setAll('[data-echo-version]', onV.dataset.title || ''); }

      var hasCmp = +get(sel, 'has-cmp') > 0;
      [].forEach.call(wrapEl.querySelectorAll('[data-price-was]'), function (e) {
        e.hidden = !hasCmp;
        e.textContent = get(sel, 'cmp');
      });
      [].forEach.call(wrapEl.querySelectorAll('[data-price-save]'), function (e) {
        var pct = +get(sel, 'save');
        e.hidden = !(hasCmp && pct > 0);
        e.textContent = (e.dataset.word || '') + ' ' + pct + '%';
      });

      versions.forEach(function (v) {
        var l = v.closest('.vopt');
        if (l) { l.classList.toggle('is-on', v.checked); }
      });
    };

    versions.concat(rows).forEach(function (i) { i.addEventListener('change', paint); });
    paint();

    /* ── The picker ──────────────────────────────────────────────────────
       The input IS the line item property, so there is nothing to copy into
       a hidden field. This only keeps the swatch row's label in step. */
    var picks = [].slice.call(root.querySelectorAll('input[data-sh-pick]'));
    var echo = root.querySelector('[data-sh-pick-echo]');
    if (picks.length) {
      var paintPick = function () {
        picks.forEach(function (p) {
          var l = p.closest('.psw') || p.closest('.pcard');
          if (l) { l.classList.toggle('is-on', p.checked); }
        });
        var on = picks.filter(function (p) { return p.checked; })[0];
        if (echo && on) { echo.textContent = on.dataset.label || on.value; }
      };
      picks.forEach(function (p) { p.addEventListener('change', paintPick); });
      paintPick();
    }

    /* ── Delivery estimate ───────────────────────────────────────────────
       Worked out from today in the browser rather than typed into the page,
       so it cannot go stale, and worded as an estimate because that is what
       it is. The two bounds are settings on the shipping block. */
    var ship = root.querySelector('.ship');
    if (ship) {
      var out = ship.querySelector('[data-eta]');
      var lo = new Date(); lo.setDate(lo.getDate() + (+ship.dataset.etaMin || 4));
      var hi = new Date(); hi.setDate(hi.getDate() + (+ship.dataset.etaMax || 7));
      var fmt = function (d) { return d.toLocaleDateString(document.documentElement.lang || 'en', { weekday: 'short', month: 'short', day: 'numeric' }); };
      if (out) { out.textContent = fmt(lo) + ' – ' + fmt(hi); }
    }

    /* ── Sticky bar ──────────────────────────────────────────────────────
       The rootMargin is the whole trick. An IntersectionObserver only calls
       back when the ratio CROSSES a threshold. With a plain viewport root
       the button starts below the fold at ratio 0, and a jump to the footer
       leaves it above the fold at ratio 0 — nothing crossed, nothing fires,
       the bar never appears. Extending the root a million pixels DOWNWARD
       makes "still here or still below" a real 0-to-1 crossing. */
    var bar = wrapEl.querySelector('[data-sh-sticky]');
    var anchor = root.querySelector('.atc');
    if (bar && anchor && 'IntersectionObserver' in window) {
      bar.hidden = false;
      new IntersectionObserver(function (entries) {
        var last = entries[entries.length - 1];
        bar.classList.toggle('is-up', !last.isIntersecting);
      }, { threshold: 0, rootMargin: '0px 0px 999999px 0px' }).observe(anchor);
    }
  }
  function scan(ctx) {
    var scope = ctx && ctx.querySelectorAll ? ctx : document;
    [].forEach.call(scope.querySelectorAll('[data-sh-buy]'), init);
    if (scope !== document && scope.matches && scope.matches('[data-sh-buy]')) init(scope);
  }
  scan(document);
  document.addEventListener('shopify:section:load', function (e) { scan(e.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sh-faq"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';
  function init(root) {
    if (root.dataset.shReady === '1') return;
    root.dataset.shReady = '1';
    var all = [].slice.call(root.querySelectorAll('details'));
    if (all.length < 2) { return; }

    /* Everything here is an enhancement. With the script gone the details
       elements still open — they just all stay open at once. */
    if (root.getAttribute('data-solo') !== 'true') { return; }
    all.forEach(function (d) {
      d.addEventListener('toggle', function () {
        if (!d.open) { return; }
        all.forEach(function (o) { if (o !== d) { o.open = false; } });
      });
    });
  }
  function scan(ctx) {
    var scope = ctx && ctx.querySelectorAll ? ctx : document;
    [].forEach.call(scope.querySelectorAll('[data-sh-faq]'), init);
    if (scope !== document && scope.matches && scope.matches('[data-sh-faq]')) init(scope);
  }
  scan(document);
  document.addEventListener('shopify:section:load', function (e) { scan(e.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sh-fit"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';
  function init(root) {
    if (root.dataset.shReady === '1') return;
    root.dataset.shReady = '1';
    var range = root.querySelector('[data-fit-range]');
    var units = [].slice.call(root.querySelectorAll('[data-fit-unit]'));
    var shoeEl = root.querySelector('[data-fit-shoe]');
    var out = root.querySelector('[data-fit-out]');
    var head = root.querySelector('[data-fit-head]');
    var val = root.querySelector('[data-fit-val]');
    var bagEl = root.querySelector('[data-fit-bag]');
    if (!range || !out || !head || !val) { return; }

    /* Every number here is the bag's own published figure, carried in on a
       data- attribute. The script converts and subtracts; it invents
       nothing, and there is no currency in sight so no rounding trap. */
    var BAG = parseFloat(root.getAttribute('data-bag')) || 15.8;
    var TIGHT = parseFloat(root.getAttribute('data-tight')) || 3;
    var unit = 'in';

    var fmt = function (inches) {
      return unit === 'in'
        ? inches.toFixed(1) + ' ' + (root.getAttribute('data-unit-in') || 'in')
        : (inches * 2.54).toFixed(1) + ' ' + (root.getAttribute('data-unit-cm') || 'cm');
    };

    var fill = function (tpl, shoe, gap) {
      return String(tpl || '')
        .split('{shoe}').join(fmt(shoe))
        .split('{bag}').join(fmt(BAG))
        .split('{gap}').join(fmt(Math.abs(gap)));
    };

    var paint = function () {
      var shoe = parseFloat(range.value);
      var gap = BAG - shoe;
      var state = gap <= 0 ? 'no' : (gap < TIGHT ? 'tight' : 'yes');

      val.textContent = fmt(shoe);
      if (shoeEl) { shoeEl.style.height = Math.min(100, (shoe / BAG) * 100) + '%'; }
      if (bagEl) { bagEl.textContent = fmt(BAG); }

      root.setAttribute('data-fit-state', state);
      head.textContent = root.getAttribute('data-head-' + state) || '';
      out.innerHTML = fill(root.getAttribute('data-msg-' + state), shoe, gap);
    };

    range.addEventListener('input', paint);

    root.addEventListener('click', function (e) {
      var q = e.target.closest('[data-fit-quick]');
      if (q) { range.value = q.getAttribute('data-fit-quick'); paint(); return; }
      var u = e.target.closest('[data-fit-unit]');
      if (u) {
        unit = u.getAttribute('data-fit-unit');
        units.forEach(function (b) {
          var on = b.getAttribute('data-fit-unit') === unit;
          b.classList.toggle('is-on', on);
          b.setAttribute('aria-pressed', on ? 'true' : 'false');
        });
        paint();
      }
    });

    paint();
  }
  function scan(ctx) {
    var scope = ctx && ctx.querySelectorAll ? ctx : document;
    [].forEach.call(scope.querySelectorAll('[data-sh-fit]'), init);
    if (scope !== document && scope.matches && scope.matches('[data-sh-fit]')) init(scope);
  }
  scan(document);
  document.addEventListener('shopify:section:load', function (e) { scan(e.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sh-review"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';
  function init(root) {
    if (root.dataset.shReady === '1') return;
    root.dataset.shReady = '1';
    var chips = [].slice.call(root.querySelectorAll('[data-chip]'));
    var cards = [].slice.call(root.querySelectorAll('.rv'));
    var count = root.querySelector('[data-rv-count]');
    var more = root.querySelector('[data-rv-more]');
    var empty = root.querySelector('[data-rv-empty]');
    if (!cards.length) { return; }

    var FOLD = +root.getAttribute('data-fold') || 6;
    var TPL_SOME = root.getAttribute('data-tpl-some') || 'Showing {n} of {all}';
    var TPL_ALL = root.getAttribute('data-tpl-all') || 'Showing all {all}';
    var CRIT = +root.getAttribute('data-critical-at') || 3;
    var open = false;

    cards.forEach(function (c, i) { if (i >= FOLD) { c.setAttribute('data-more', ''); } });

    var paint = function (topic) {
      /* Count what is on screen, not what matched. Those are different
         numbers while the wall is folded, and a counter that says "all 12"
         over six visible cards is the page contradicting itself. */
      var shown = 0;
      cards.forEach(function (c) {
        var match = topic === 'all' ||
          (topic === 'critical' ? +c.getAttribute('data-stars') <= CRIT : c.getAttribute('data-topic') === topic);
        /* Folding only applies while the wall is unfiltered. Once you have
           asked for one topic, hiding half the answer is just rude. */
        var folded = !open && topic === 'all' && c.hasAttribute('data-more');
        c.hidden = !match || folded;
        if (!c.hidden) { shown++; }
      });
      if (count) {
        count.textContent = (shown === cards.length ? TPL_ALL : TPL_SOME)
          .split('{n}').join(shown).split('{all}').join(cards.length);
      }
      if (empty) { empty.hidden = shown > 0; }
      if (more) { more.hidden = open || topic !== 'all' || cards.length <= FOLD; }
    };

    root.addEventListener('click', function (e) {
      var chip = e.target.closest('[data-chip]');
      if (chip) {
        chips.forEach(function (c) {
          var on = c === chip;
          c.classList.toggle('is-on', on);
          c.setAttribute('aria-pressed', on ? 'true' : 'false');
        });
        paint(chip.getAttribute('data-chip'));
        return;
      }
      if (e.target.closest('[data-rv-more]')) {
        open = true;
        var active = chips.filter(function (c) { return c.classList.contains('is-on'); })[0];
        paint(active ? active.getAttribute('data-chip') : 'all');
      }
    });

    paint('all');
  }
  function scan(ctx) {
    var scope = ctx && ctx.querySelectorAll ? ctx : document;
    [].forEach.call(scope.querySelectorAll('[data-sh-reviews]'), init);
    if (scope !== document && scope.matches && scope.matches('[data-sh-reviews]')) init(scope);
  }
  scan(document);
  document.addEventListener('shopify:section:load', function (e) { scan(e.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sh-use"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';
  function init(root) {
    if (root.dataset.shReady === '1') return;
    root.dataset.shReady = '1';
    var tabs = [].slice.call(root.querySelectorAll('[role="tab"]'));
    var panels = [].slice.call(root.querySelectorAll('[role="tabpanel"]'));
    if (!tabs.length) { return; }

    var select = function (id, focus) {
      tabs.forEach(function (t) {
        var on = t.getAttribute('data-use') === id;
        t.setAttribute('aria-selected', on ? 'true' : 'false');
        t.tabIndex = on ? 0 : -1;
        if (on && focus) { t.focus(); }
      });
      panels.forEach(function (p) { p.hidden = p.getAttribute('data-use-panel') !== id; });
    };

    root.addEventListener('click', function (e) {
      var t = e.target.closest('[role="tab"]');
      if (t) { select(t.getAttribute('data-use')); }
    });

    root.addEventListener('keydown', function (e) {
      var t = e.target.closest('[role="tab"]');
      if (!t) { return; }
      var i = tabs.indexOf(t), n = null;
      if (e.key === 'ArrowRight') { n = (i + 1) % tabs.length; }
      else if (e.key === 'ArrowLeft') { n = (i - 1 + tabs.length) % tabs.length; }
      else if (e.key === 'Home') { n = 0; }
      else if (e.key === 'End') { n = tabs.length - 1; }
      if (n === null) { return; }
      e.preventDefault();
      select(tabs[n].getAttribute('data-use'), true);
    });

    select(tabs[0].getAttribute('data-use'));
  }
  function scan(ctx) {
    var scope = ctx && ctx.querySelectorAll ? ctx : document;
    [].forEach.call(scope.querySelectorAll('[data-sh-uses]'), init);
    if (scope !== document && scope.matches && scope.matches('[data-sh-uses]')) init(scope);
  }
  scan(document);
  document.addEventListener('shopify:section:load', function (e) { scan(e.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sh-version"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';
  function init(root) {
    if (root.dataset.shReady === '1') return;
    root.dataset.shReady = '1';
    var boxes = [].slice.call(root.querySelectorAll('[data-pick-q]'));
    var out = root.querySelector('[data-pick-out]');
    var cards = [].slice.call(document.querySelectorAll('[data-ver]'));
    if (!out) { return; }

    var WIN = root.getAttribute('data-win') || 'pro';
    var LOSE = root.getAttribute('data-lose') || 'lite';
    var touched = false;

    var paint = function () {
      var want = boxes.filter(function (b) { return b.checked; });
      var pick = touched ? (want.length ? WIN : LOSE) : null;

      cards.forEach(function (c) { c.classList.toggle('is-pick', c.getAttribute('data-ver') === pick); });

      if (!touched) {
        out.innerHTML = root.getAttribute('data-msg-idle') || '';
      } else if (!want.length) {
        out.innerHTML = root.getAttribute('data-msg-none') || '';
      } else {
        var why = want.map(function (b) { return b.getAttribute('data-why') || ''; })
          .filter(Boolean).join(' ' + (root.getAttribute('data-join') || 'and') + ' ');
        out.innerHTML = String(root.getAttribute('data-msg-any') || '').split('{why}').join(why);
      }
    };

    boxes.forEach(function (b) {
      b.addEventListener('change', function () { touched = true; paint(); });
    });
    paint();
  }
  function scan(ctx) {
    var scope = ctx && ctx.querySelectorAll ? ctx : document;
    [].forEach.call(scope.querySelectorAll('[data-sh-pick]'), init);
    if (scope !== document && scope.matches && scope.matches('[data-sh-pick]')) init(scope);
  }
  scan(document);
  document.addEventListener('shopify:section:load', function (e) { scan(e.target); });
})();

  } catch(e) { console.error(e); }
})();
})();
